import React from "react";
import { ArrowBackOutline, ArrowForwardOutline } from "react-ionicons";
import constantURI from "../URI";
import _post from "../Functions/Post";
import _postBody from "../Functions/Post";
import SearchFilterFunction from "../Functions/SearchFilterTransactionAsap";
import ASAPAuthenticate from "../Functions/ASAPAuthenticate";
import stylesASAP from "./stylesASAP";
import { v4 as uuidv4 } from "uuid";
import {
  AiOutlineUnorderedList,
  AiFillFilter,
  AiOutlineFilter,
} from "react-icons/ai";
import { BsFillGrid3X3GapFill } from "react-icons/bs";
import stylesMed from "../MedRep/stylesMed";
import { Modal } from "react-bootstrap";
import SignaturePad from "react-signature-pad-wrapper";
import { ArrowBackCircle } from "react-ionicons";
import { db, getDocs, collection, disableNetwork } from "../firebase";
import Print from "./Print";
import FilterFunction from "../Functions/Filter";
import normalizeUnsyncedTransactions from "../Functions/normalizeUnsyncedTransactions";
import {
  FcManager,
  FcBarChart,
  FcBullish,
  FcBearish,
  FcCalendar,
  FcComboChart,
  FcSurvey,
  FcSalesPerformance,
  FcNews,
  FcSynchronize,
  FcCancel,
  FcBusinessman,
  FcSearch,
  FcFilledFilter,
  FcDoughnutChart,
  FcList,
} from "react-icons/fc";
import { SlBasket } from "react-icons/sl";
import { GrCatalog } from "react-icons/gr";
import { set, get } from "idb-keyval";
import e from "cors";

export default class TransactionASAP extends React.Component {
  constructor() {
    super();
    this.state = {
      loading: true,
      checked: [],
      allitems: [],
      catalogId: 0,
      items: [],
      itemsCopy: [],
      SOL: [],
      SOId: 0,
      SoLog: [],
      SOLId: 0,
      count: 0,
      UST: [],
      taxes: [],
      totalPrice: 0,
      totalWeight: 0,
      isTaxQty: [],
      isTaxDisc: [],
      SOBody: [],
      lastSo: [],
      selectedClient: 0,
      pricelist: [],
      pricelistPrices: [],
      products: [],
      token: "",
      lastLineInfo: [],
      authenticate: false,
      free: [],
      stock: [],
      stockTemp: [],
      location: [],
      globalDiscount: 0,
      totalOrderPriceUntaxed: 0,
      totalOrderPriceTaxed: 0,
      selectedClientName: "",
      Date: new Date().toISOString().substring(0, 10),
      SO: [],
      SOLs: [],
      showAlertChange: false,
      showAlertPreview: false,
      showAlertRemark: false,
      showAlertImages: false,
      inputValue: "",
      showAlertCancel: false,
      missingStocks: [],
      missingTaxes: [],
      remainingEmpty: [],
      preventSymbols: ["e", "E", "+", "-", ".", ","],
      picking: [],
      move: [],
      orderLines: [],
      SOLOOR: 0,
      transferId: 0,
      emptyProducts: [],
      isGrid: false,
      SOLBody: [],
      alertUndefined: false,
      isEmpty: false,
      pricelistList: [],
      currentType: -1,
      originalTransactions: [],
      originalCount: [],
      barcode: "",
      isTTC: false,
      order: [],
      delivery: [],
      totalVAT: 0,
      clients: [],
      isDelivery: false,
      offset: 0,
      showPrint: false,
      username: "",
      offsetFixed: 0,
      isEdit: false,
      EditId: -1,
      checkSignature: true,
      user: [],
      countP: 1,
      countC: 0,
      catalogs: [],
      catalogid: 1,
      ofproducts: 1,
      isFilter: false,
      isFilterQty: false,
      showAlertimage: false,
      selectedClientDetails: [],
      dailySummaryReport: [],
      isSchedule: -1,
      isVendor: false,
      dailyData: [],
      productFamily: "",
      productCateg: "",
      productBrand: "",
      productGroup: "",
      selectFamily: "",
      selectCateg: "",
      selectBrand: "",
      selectGroup: "",
      isfamily: false,
      description: "",
      interval: 0,
      equalqty: "isequal",
      enter: false,
      imageLoaded: false,
      intervalp: 0,
      nextp: false,
      showAlertCatalog: false,
      settingArray: [],
      random: 0,
      UserId: 0,
      SalesType: [],
      countTrans: 0,
      ProductPromotion: [],
      fixed: 0,
      searchText: "",

      //Predefined ids for the transaction types
      transactionTypes: [
        {
          id: 0,
          name: "Order",
          SOs: "CreateSO?token=",
          type: "SAL",
          LS: "SO",
          signature: "updateSO?token=",
        },
        {
          id: 1,
          name: "Return",
          SOs: "CreateSO?token=",
          type: "RO",
          LS: "Return",
          signature: "updateSO?token=",
        },
        {
          id: 2,
          name: "Purchase",
          SOs: "CreatePO?token=",
          type: "RFQ",
          LS: "PO",
          signature: "updatePO?token=",
        },
        { id: 3, name: "Invoices", signature: "updateInvoice?token=" },
        {
          id: 4,
          name: "Delivery",
          SOs: "CreateSO?token=",
          type: "DLV",
          LS: "Delivery",
          signature: "updateSO?token=",
        },
        {
          id: 5,
          name: "CashSales",
          SOs: "CreateSO?token=",
          type: "CSH",
          LS: "CSH",
          signature: "updateSO?token=",
        },
      ],
    };
    this.sign = React.createRef();
  }

  componentWillUnmount() {
    if (this.unblock) {
      this.unblock();
    }
  }

  async componentDidMount() {
    document.body.style.backgroundColor = "#e6e6fa";

    //Get the needed data from local storage
    const { history } = this.props;
    this.unblock = history.block(() => {
      // Return false to deny the navigation
      return false;
    });
    await this.getLocalStorage();
    const catalogId = JSON.parse(localStorage.getItem("CatalogId"));
    const catalogs = JSON.parse(localStorage.getItem("Catalogs"));
    const productFamily = JSON.parse(localStorage.getItem("ProductFamily"));
    const productCateg = JSON.parse(localStorage.getItem("ProductCateg"));
    const productBrand = JSON.parse(localStorage.getItem("ProductBrand"));
    const productGroup = JSON.parse(localStorage.getItem("ProductGroup"));
    const username = JSON.parse(localStorage.getItem("Username"));
    const savesol = JSON.parse(localStorage.getItem("SaveSol"));
    const lastSo = JSON.parse(localStorage.getItem("SoLogLastIndex"));
    const savetotal = JSON.parse(localStorage.getItem("SaveTotal"));
    const SalesType = JSON.parse(localStorage.getItem("SalesType"));
    const SelectedClientName = JSON.parse(
      localStorage.getItem("SelectedClientName"),
    );
    const TotalWeight = JSON.parse(localStorage.getItem("TotalWeight"));
    const SelectedClient = JSON.parse(localStorage.getItem("SelectedClient"));
    const settingArray = JSON.parse(localStorage.getItem("SettingArray"));
    const random = JSON.parse(localStorage.getItem("random"));
    const UserId = JSON.parse(localStorage.getItem("UserId"));
    const countTrans = JSON.parse(localStorage.getItem("countTrans"));
    const SelectedClientDetails = JSON.parse(
      localStorage.getItem("SelectedClientDetails"),
    );
    const ProductPromotion = JSON.parse(
      localStorage.getItem("ProductPromotion"),
    );
    this.setState({
      username: username,
      catalogs: catalogs,
      catalogid: catalogId,
      productFamily: productFamily,
      productCateg: productCateg,
      productBrand: productBrand,
      productGroup: productGroup,
      SOL: savesol === null ? [] : savesol,
      totalOrderPriceTaxed: savetotal,
      totalWeight: TotalWeight === null ? 0 : TotalWeight,
      SelectedClientName: SelectedClientName,
      SelectedClient: SelectedClient,
      lastSo: lastSo,
      settingArray: settingArray,
      random: random,
      UserId: UserId,
      SalesType: SalesType,
      countTrans: countTrans,
      ProductPromotion: ProductPromotion,
      SelectedClientDetails : SelectedClientDetails
    });
    const precision = Number(
      settingArray.find((item) => item.key === "PricesDigitPrecesion")?.value,
    );
    if (precision !== undefined && precision !== null) {
      this.setState({ fixed: precision });
    } else {
      this.setState({ fixed: 2 });
    }

    console.log(this.state.SOL);
    const isEdit = JSON.parse(localStorage.getItem("isEdit"));
    var SOID = JSON.parse(localStorage.getItem("USOrderId"));
    //If this transaction is edit and not create
    if (isEdit) {
      await this.setState({
        globalDiscount: Number(isEdit.globalDiscount),
        isEdit: true,
        EditId: Number(SOID),
        usId: Number(isEdit.usId),
        EditName: isEdit.name,
      });
      // Build a clean SOL map from edited lines to avoid null/undefined entries
      const solCopy = Array.isArray(this.state.SOL) ? [...this.state.SOL] : [];
      for (const line of isEdit.Lines || []) {
        if (!line) continue;
        const pid = line.productId ?? line.product_id;
        if (pid === undefined || pid === null) continue;
        const entry = {
          id: pid,
          productId: line.product_id ?? null,
          name: line.name ?? "",
          price: line.price ?? 0,
          unitPrice: line.unitPrice ?? null,
          fixedprice: line.fixedprice ?? null,
          packages: line.packages ?? null,
          qty: line.product_uom_qty !== undefined ? line.product_uom_qty : null,
          disc: line.discount !== undefined ? line.discount : null,
          descrip: line.descrip !== undefined ? line.descrip : null,
          remark: line.remark !== undefined ? line.remark : null,
          freeItem: line.freeItem !== undefined ? line.freeItem : null,
          totalPrice:
            line.price_total !== undefined ? line.price_total : null,
          totalPriceGlobal:
            line.price_total !== undefined ? line.price_total : null,
          totalPriceUntaxedGlobal:
            line.totalPriceUntaxed !== undefined
              ? line.totalPriceUntaxed
              : null,
          itemTaxGlobal:
            line.itemTax !== undefined ? line.itemTax : null,
        };
        solCopy[pid] = entry;
      }
      await this.setState({ SOL: solCopy });
    }
    console.log(this.state.SOL);
    this.state.catalogs.map((item, index) => {
      if (item.id === this.state.catalogid) {
        this.setState({ countC: index + 1 });
      }
    });
    await this.compOffline();
    await this.calculateTaxedAmount();
    await this.calculateUntaxedAmount();
    await this.calculateTax();
    console.log(this.state.SOL);
    //When getting data if either stock or tax are undefined set them to 0
    await this.setState({
      missingTaxes: this.state.items.filter((e) => e.taxes_id.length === 0),
    });
    //Check if the pricelist of the current client is TTC
    await this.checkTTC();
    if (this.state.currentType === 2) {
      await this.setState({
        isVendor: true,
        ...(this.state.transactionTypes[4].SOs = "CreatePO?token="),
        ...(this.state.transactionTypes[4].signature = "updatePO?token="),
      });
    }
    //If current type is delivery
    if (this.state.isDelivery) {
      await this.setBarcode();
      await this.setState({
        currentType: 4,
        isGrid: false,
        items: this.state.orderLines,
        enableSave: true,
        loading: false,
      });
    }
    const interval = setInterval(async () => {
      await this.onhold();
    }, 1000);
    this.setState({ interval: interval });

    const interval1 = setInterval(async () => {
      await this.onholdpage();
    }, 2000);
    this.setState({ intervalp: interval });

    await this.sortItems();
    console.log(this.state.SOL);
  }

  // async componentDidUpdate(prevProps, prevState) {
  //   if (prevState.SOL !== this.state.SOL) {
  //   await  this.calculateAndSetTotalLines ();
  //   }
  // }
  handleImageLoad(defaultCode) {
    this.setState({ imageLoaded: true });
  }
  loadData = async () => {
    localStorage.setItem(
      "SaveSol",
      JSON.stringify(this.state.lastSo[0].lineInfo),
    );
    await this.setState({ SOL: this.state.lastSo[0].lineInfo });
  };

  onhold = () => {
    localStorage.setItem("SaveSol", JSON.stringify(this.state.SOL));
    localStorage.setItem(
      "SaveTotal",
      JSON.stringify(this.state.totalOrderPriceTaxed),
      localStorage.setItem(
        "TotalWeight",
        JSON.stringify(this.state.totalWeight),
      ),
    );

    console.log(this.state.SOL);
  };

  stopInterval = () => {
    // Stop the interval using clearInterval
    clearInterval(this.state.interval);
  };

  readData = async () => {
    try {
      // Use 'get' method from idb-keyval to read data from IndexedDB
      const data = await get("PriceList");

      if (data) {
        this.setState({ pricelistList: data });
        console.log("PriceList from IndexedDB:", data);
      } else {
        console.log("PriceList not found in IndexedDB.");
      }
    } catch (error) {
      console.error("Error reading PriceList from IndexedDB:", error);
    }
  };

  readItems = async () => {
    try {
      // Use 'get' method from idb-keyval to read data from IndexedDB
      const data = await get("items");

      if (data) {
        const filteredData = data.filter(
          (item) =>
            item.pricelist_id[0] ===
            this.state.selectedClientDetails.property_product_pricelist[0] &&
            item.external_onhand_qty !== "false" &&
            parseFloat(item.external_onhand_qty) > 0,
        );

        this.setState({ allitems: filteredData });
        console.log("items from IndexedDB:", data);
      } else {
        console.log("items not found in IndexedDB.");
      }
    } catch (error) {
      console.error("Error reading items from IndexedDB:", error);
    }
  };

  readClients = async () => {
    try {
      // Use 'get' method from idb-keyval to read data from IndexedDB
      const data = await get("Clients");

      if (data) {
        this.setState({ clients: data, clientsCopy: data, loading: false });
        console.log("Clients from IndexedDB:", data);
      } else {
        console.log("Clients not found in IndexedDB.");
      }
    } catch (error) {
      console.error("Error reading Clients from IndexedDB:", error);
    }

    //Get Client by Id
    var result = [];
    await this.state.clients.map((client, index) => {
      if (client.id === this.state.selectedClient) {
        result.push(client);
      }
    });
    await this.setState({ pricelist: result });
  };

  compOffline = async () => {
    //Get data from local storage
    var clients = [];
    if (this.state.isVendor) {
      clients = localStorage.getItem("Vendors");
      await this.setState({ clients: JSON.parse(clients) });
    } else {
      await this.readClients();
    }

    await this.readData();
    await this.readItems();
    const taxes = localStorage.getItem("Taxes");
    const location = localStorage.getItem("Location");

    await this.setState({
      taxes: JSON.parse(taxes),
      location: JSON.parse(location),
    });
    if (!this.state.isDelivery) await this.setCurrentCatalog();
  };

  setCurrentCatalog = async () => {
    var categItemsOffline = [];
    if (this.state.catalogId === 1) {
      this.setState({
        items: this.state.allitems,
        itemsCopy: this.state.allitems,
        loading: false,
        ofproducts: Math.round(this.state.allitems.length / 8),
      });
      if (this.state.allitems.length <= 8) {
        this.setState({ ofproducts: 1 });
      } else {
        this.setState({
          ofproducts: Math.round(this.state.allitems.length / 8),
        });
      }
    } else {
      this.state.allitems.forEach((item) => {
        if (item.categ_id[0] === this.state.catalogId) {
          categItemsOffline.push(item);
        }
      });
      this.setState({
        items: categItemsOffline,
        itemsCopy: categItemsOffline,
        loading: false,
        ofproducts: Math.round(categItemsOffline.length / 8),
      });
      if (categItemsOffline.length === 0) {
        this.setState({ ofproducts: 1 });
      }
    }
  };

  getLocalStorage = async () => {
    const type = JSON.parse(localStorage.getItem("TransactionType"));
    const delivery = JSON.parse(localStorage.getItem("IsDelivery"));
    const user = JSON.parse(localStorage.getItem("User"));
    const isEdit = JSON.parse(localStorage.getItem("isEdit"));
    var SOID = JSON.parse(localStorage.getItem("USOrderId"));
    //If this transaction is edit and not create
    if (isEdit) {
      await this.setState({
        globalDiscount: Number(isEdit.globalDiscount),
        isEdit: true,
        EditId: Number(SOID),
        usId: Number(isEdit.usId),
        EditName: isEdit.name,
      });
      // Safely build SOL from edit lines
      const solCopy = Array.isArray(this.state.SOL) ? [...this.state.SOL] : [];
      for (const line of isEdit.Lines || []) {
        if (!line) continue;
        const pid = line.productId ?? line.product_id;
        if (pid === undefined || pid === null) continue;
        solCopy[pid] = {
          id: pid,
          productId: line.product_id ?? null,
          name: line.name ?? "",
          packages: line.packages ?? null,
          qty: line.product_uom_qty !== undefined ? line.product_uom_qty : null,
          disc: line.discount !== undefined ? line.discount : null,
          descrip: line.descrip !== undefined ? line.descrip : null,
          remark: line.remark !== undefined ? line.remark : null,
          freeItem: line.freeItem !== undefined ? line.freeItem : null,
          totalPrice: line.price_total !== undefined ? line.price_total : null,
          totalPriceGlobal: line.price_total !== undefined ? line.price_total : null,
          totalPriceUntaxedGlobal:
            line.totalPriceUntaxed !== undefined ? line.totalPriceUntaxed : null,
          itemTaxGlobal: line.itemTax !== undefined ? line.itemTax : null,
        };
      }
      await this.setState({ SOL: solCopy });
    }
    await this.setState({
      currentType: JSON.parse(type),
      isDelivery: delivery,
      user: user,
    });
    //If current type is purchase order then the clients are vendors
    if (this.state.currentType === 2) {
      this.setState({ isVendor: true });
    }
    //If current type is Delivery
    if (this.state.isDelivery) {
      const order = JSON.parse(localStorage.getItem("CheckedOrder"));
      const orderLines = JSON.parse(localStorage.getItem("CheckedOrderLine"));
      await this.setState({ orderLines: orderLines, order: order });
      if (orderLines !== null) {
        if (orderLines.length === 0) {
          await this.setState({ isEmpty: true });
        }
      }
    }
    //Get needed data from local storage
    const { counts: count, transactions } = normalizeUnsyncedTransactions();
    const dailyData = JSON.parse(localStorage.getItem("DailyData"));
    const dailySummaryReport = JSON.parse(
      localStorage.getItem("DailySummaryReport"),
    );
    const catalogs = JSON.parse(localStorage.getItem("Catalogs"));
    const catalogId = JSON.parse(localStorage.getItem("CatalogId"));
    const isGrid = JSON.parse(localStorage.getItem("IsGrid"));
    const selectedClient = JSON.parse(localStorage.getItem("SelectedClient"));
    const selectedClientName = JSON.parse(
      localStorage.getItem("SelectedClientName"),
    );
    const selectedClientDetails = JSON.parse(
      localStorage.getItem("SelectedClientDetails"),
    );
    const token = JSON.parse(localStorage.getItem("Token"));
    const isSchedule = JSON.parse(localStorage.getItem("isSchedule"));

    await this.setState({
      count:
        count.length !== 0 && count[this.state.currentType] !== undefined
          ? count[this.state.currentType]
          : 0,
      UST:
        transactions.length !== 0 &&
        transactions[this.state.currentType] !== undefined
          ? transactions[this.state.currentType]
          : [],
      selectedClient: selectedClient,
      token: token,
      selectedClientName: selectedClientName,
      originalTransactions: transactions,
      dailyData: dailyData,
      originalCount: count,
      catalogs: catalogs,
      catalogId: catalogId,
      isGrid: isGrid,
      selectedClientDetails: selectedClientDetails,
      dailySummaryReport:
        dailySummaryReport.length === 0
          ? [
              {
                ordered: 0,
                visited: 0,
                collection: 0,
                OOR: 0,
              },
            ]
          : dailySummaryReport,
      isSchedule: isSchedule,
      type: type,
    });
  };

  setBarcode = async () => {
    await this.state.products.map(async (item) => {
      await this.state.orderLines.map((line, index) => {
        if (item.id === line.product_id[0]) {
          this.setState({
            ...(this.state.orderLines[index].barcode = item.item.name.substring(
              item.name.indexOf("[") + 1,
              item.name.indexOf("]"),
            )),
          });
        }
      });
    });
  };

  //Check if the pricelist of the selected customer has TTC
  checkTTC = async () => {
    await this.state.pricelistList.map((pricelist) => {
      if (this.state.pricelist[0].property_product_pricelist !== undefined) {
        if (
          pricelist.id === this.state.pricelist[0].property_product_pricelist[0]
        ) {
          this.setState({ isTTC: pricelist.is_ttcprice });
        }
      }
    });
  };

  // productPromotion = (id, Item) => {
  //   if (!Item) return;

  //   const promotion = JSON.parse(Item.misctext1);
  //   if (
  //     !promotion ||
  //     promotion === "" ||
  //     promotion === false ||
  //     promotion === "false"
  //   )
  //     return;

  //   const targetQty = this.state.SOL[id].qty;

  //   // Sort promotions descending by OriginItemQty
  //   const sortedPromotions = promotion
  //     .filter((p) => p.OriginItemQty > 0) // ensure valid
  //     .sort((a, b) => b.OriginItemQty - a.OriginItemQty);

  //   let remainingQty = targetQty;
  //   let totalFreeItems = 0;

  //   for (const promo of sortedPromotions) {
  //     if (promo.OriginItemCode !== Item.default_code) continue;

  //     const sets = Math.floor(remainingQty / promo.OriginItemQty);
  //     if (sets > 0) {
  //       totalFreeItems += sets * promo.FreeItemQty;
  //       remainingQty -= sets * promo.OriginItemQty;
  //     }
  //   }

  //   // Update state
  //   this.setState({
  //     ...(this.state.SOL[id].freeItem = totalFreeItems),
  //   });
  // };

  productPromotion = async (id, Item) => {
    if (!Item) return;

    const promotion = JSON.parse(Item.misctext1);
    if (
      !promotion ||
      promotion === "" ||
      promotion === false ||
      promotion === "false"
    ) {
      const solCopy = Array.isArray(this.state.SOL) ? [...this.state.SOL] : [];
      const existing = solCopy[id] || {};
      solCopy[id] = {
        ...existing,
        freeItem: 0,
        id: id,
        productId: id,
        name: Item.name,
      };
      await this.setState({ SOL: solCopy });
      return;
    }

    const targetQty = this.state.SOL[id]?.qty ?? 0;

    // Sort promotions descending by OriginItemQty
    const sortedPromotions = promotion
      .filter((p) => p.OriginItemQty > 0) // ensure valid
      .sort((a, b) => b.OriginItemQty - a.OriginItemQty);

    let remainingQty = targetQty;
    let totalFreeItems = 0;

    // Build a safe SOL copy and clear any stale promo values before recalculating
    const solCopy = Array.isArray(this.state.SOL) ? [...this.state.SOL] : [];
    const affectedRowIds = new Set([id]);

    for (const promo of sortedPromotions) {
      if (promo.OriginItemCode !== Item.default_code) continue;

      const baseRow = solCopy[id] || {};
      solCopy[id] = {
        ...baseRow,
        freeItem: 0,
        id: id,
        productId: id,
        name: Item.name,
      };

      if (promo.FreeItemCode !== Item.default_code) {
        const itemProm = this.state.allitems.find(
          (it) => it.default_code === promo.FreeItemCode,
        );
        if (!itemProm || itemProm.id === undefined) continue;

        affectedRowIds.add(itemProm.id);
        const freeExisting = solCopy[itemProm.id] || {};
        solCopy[itemProm.id] = {
          ...freeExisting,
          freeItem: 0,
          id: itemProm.id,
          productId: itemProm.id,
          name: itemProm.name,
        };
      }
    }

    for (const promo of sortedPromotions) {
      if (promo.OriginItemCode !== Item.default_code) continue;
      const sets = Math.floor(remainingQty / promo.OriginItemQty);
      if (sets <= 0) continue;
      const added = sets * promo.FreeItemQty;
      remainingQty -= sets * promo.OriginItemQty;

      if (promo.FreeItemCode !== Item.default_code) {
        const itemProm = this.state.allitems.find(
          (it) => it.default_code === promo.FreeItemCode,
        );
        if (!itemProm || itemProm.id === undefined) continue;
        const existing = solCopy[itemProm.id] || {};
        solCopy[itemProm.id] = {
          ...existing,
          freeItem: (existing.freeItem || 0) + added,
          id: itemProm.id,
          productId: itemProm.id,
          name: itemProm.name,
        };
      } else {
        const existing = solCopy[id] || {};
        solCopy[id] = {
          ...existing,
          freeItem: (existing.freeItem || 0) + added,
          id: id,
          productId: id,
          name: Item.name,
        };
      }
      totalFreeItems += added;
    }

    if (targetQty === 0 && !affectedRowIds.has(id)) {
      const existing = solCopy[id] || {};
      solCopy[id] = {
        ...existing,
        freeItem: 0,
        id: id,
        productId: id,
        name: Item.name,
      };
    }

    await this.setState({ SOL: solCopy });
  };

  incrementQty = async (id, Item, pkgQty, pkgId, unit, discount) => {
    let newPackage = null;

    if (this.state.SOL[id] !== undefined && this.state.SOL[id] !== null) {
      if (this.state.SOL[id].packages === undefined) {
        newPackage = {
          packageId: pkgId,
          PackageQty: pkgQty,
          qty: 1,
          // Add any other fields you need here
        };
      } else if (this.state.SOL[id].packages !== undefined) {
        newPackage = {
          packageId: pkgId,
          PackageQty: pkgQty,
          qty: (Number(this.state.SOL[id]?.packages?.[pkgId]?.qty) || 0) + 1,
          // Add any other fields you need here
        };
      }
      const updatedPackages = {
        ...(this.state.SOL[id]?.packages || {}),
        [pkgId]: newPackage,
      };
      // const Free = this.state.SOL[id].freeItem === undefined || this.state.SOL[id].freeItem === null ? 0 : this.state.SOL[id].freeItem ;
      if (
        this.state.SOL[id].qty !== undefined &&
        this.state.SOL[id].qty !== null
      ) {
        if (pkgId !== undefined && pkgId !== null) {
          this.setState({ ...(this.state.SOL[id].packages = updatedPackages) });
        } else {
          this.setState({ totalWeight: this.state.totalWeight + Item.weight });
          this.setState({
            ...(this.state.SOL[id].updateDate = new Date()),
            ...(this.state.SOL[id].weight =
              this.state.SOL[id].weight + Item.weight),
            // ...(this.state.SOL[id].totalWeight = (this.state.SOL[id].qty + Free )*(Item.fixed_price)),
          });
        }
        if (
          discount !== null &&
          discount !== undefined &&
          discount !== false &&
          discount !== "false" &&
          this.state.SOL[id].qty === 0
        ) {
          this.state.SOL[id].disc = Number(discount);
        }

        //         if(this.state.SOL[id].qty > 0 && this.state.SOL[id].disc > 0 ){
        //           const qty = Number(this.state.SOL[id].qty);
        //           const disc = Number(this.state.SOL[id].disc);
        //  this.setState({

        //           ...(this.state.SOL[id].discAmount = Item.fixed_price
        //             ?  (Item.fixed_price * qty) * (disc / 100)
        //             : 0),
        //         });

        //         }
        this.setState((prev) => {
          const SOL = [...prev.SOL];
          const current = SOL[id] || {};

          const qty = Number(current.qty || 0);
          const disc = Number(current.disc || 0);
          const price = Number(Item.fixed_price || 0);

          const discAmount =
            qty > 0 && disc > 0 ? price * qty * (disc / 100) : 0;

          SOL[id] = {
            ...current,
            discAmount,
          };

          return { SOL };
        });
      } else {
        this.setState({ totalWeight: this.state.totalWeight + Item.weight });
        this.setState({
          ...(this.state.SOL[id].packages = updatedPackages),

          ...(this.state.SOL[id].updateDate = new Date()),
          ...(this.state.SOL[id].weight =
            this.state.SOL[id].weight + Item.weight),
          // ...(this.state.SOL[id].totalWeight = (this.state.SOL[id].qty + Free )*(Item.fixed_price)),
        });
      }
      // this.setState({ ...(this.state.SOL[id].uom = uom) });
    } else {
      this.setState({ ...(this.state.SOL[id] = {}) });
      var name =
        (Item.default_code !== false ? "[" + Item.default_code + "] " : "") +
        Item.name +
        " ";

      if (this.state.SOL[id].packages === undefined) {
        newPackage = {
          packageId: pkgId,
          PackageQty: pkgQty,
          qty: 1,
          // Add any other fields you need here
        };
      } else if (this.state.SOL[id].packages !== undefined) {
        newPackage = {
          packageId: pkgId,
          PackageQty: pkgQty,
          qty: (Number(this.state.SOL[id]?.packages?.[pkgId]?.qty) || 0) + 1,
          // Add any other fields you need here
        };
      }
      const updatedPackages = {
        ...(this.state.SOL[id]?.packages || {}),
        [pkgId]: newPackage,
      };
      // const Free = this.state.SOL[id].freeItem === undefined || this.state.SOL[id].freeItem === null ? 0 : this.state.SOL[id].freeItem ;
      this.setState({ totalWeight: this.state.totalWeight + Item.weight });
      if (
        discount !== null &&
        discount !== undefined &&
        discount !== false &&
        discount !== "false"
      ) {
        this.state.SOL[id].disc = Number(discount);
      }
      await this.setState((prev) => {
        const SOL = [...prev.SOL];
        const current = SOL[id] || {};

        const qty = Number(current.qty || 1);
        const disc = Number(current.disc || 0);
        const price = Number(Item.fixed_price || 0);

        const discAmount = qty > 0 && disc > 0 ? price * qty * (disc / 100) : 0;

        SOL[id] = {
          ...current,
          discAmount,
        };

        return { SOL };
      });
      await this.setState({
        ...(this.state.SOL[id].packages = updatedPackages),

        ...(this.state.SOL[id].id = id),
        // ...(this.state.SOL[id].disc = Number(discount)),
        ...(this.state.SOL[id].name = name),
        ...(this.state.SOL[id].uom_id = Item.uom_id[1]),
        ...(this.state.SOL[id].productId = Item.id),
        ...(this.state.SOL[id].creationDate = new Date()),
        ...(this.state.SOL[id].weight = Item.weight),
        // ...(this.state.SOL[id].totalWeight = (this.state.SOL[id].qty + Free )*(Item.fixed_price)),
      });
      // this.setState({ ...(this.state.SOL[id].uom = uom) });
    }
    await this.calculateQuantities(Item.id, pkgId);
    // await this.state.items.map(async (item) => {
    //   if (
    //     this.state.SOL[id] !== undefined &&
    //     this.state.SOL[id] !== null &&
    //     this.state.SOL[id].qty !== undefined &&
    //     this.state.SOL[id].qty !== null &&
    //     this.state.SOL[id].qty >= 0 &&
    //     (this.state.SOL[id].disc === undefined ||
    //       this.state.SOL[id].disc ===
    //         this.state.selectedClientDetails.fixed_discount)
    //   ) {
    //     await this.setState({
    //       ...(this.state.SOL[id].disc =
    //         this.state.selectedClientDetails.fixed_discount),
    //     });
    //   }
    // });
    let lstPrice;

    if (pkgQty !== undefined && pkgQty !== null) {
      lstPrice = Item.fixed_price === undefined ? 0 : Item.fixed_price;
    }

    await this.setPrices(lstPrice, id, Item.taxes_id, this.state.SOL[id].qty);
    await this.calculateUntaxedAmount();
    await this.calculateTax();
    await this.calculateTaxedAmount();
    await this.calculateAndSetTotalLines(Item.id, Item.name);
    await this.productPromotion(id, Item);

    // await this.onChangeGlobalDiscount();
  };

  // incrementQty = async (id, Item, pkgQty, pkgId , ) => {
  //   let newPackage = null;

  //   if (this.state.SOL[id] !== undefined && this.state.SOL[id] !== null) {
  //     if (this.state.SOL[id].packages === undefined) {
  //       newPackage = {
  //         packageId: pkgId,
  //         PackageQty: pkgQty,
  //         qty: 1,
  //         // Add any other fields you need here
  //       };
  //     } else if (this.state.SOL[id].packages !== undefined) {
  //       newPackage = {
  //         packageId: pkgId,
  //         PackageQty: pkgQty,
  //         qty: (Number(this.state.SOL[id]?.packages?.[pkgId]?.qty) || 0) + 1,
  //         // Add any other fields you need here
  //       };
  //     }
  //     const updatedPackages = {
  //       ...(this.state.SOL[id]?.packages || {}),
  //       [pkgId]: newPackage,
  //     };
  //     // const Free = this.state.SOL[id].freeItem === undefined || this.state.SOL[id].freeItem === null ? 0 : this.state.SOL[id].freeItem ;
  //     if (
  //       this.state.SOL[id].qty !== undefined &&
  //       this.state.SOL[id].qty !== null
  //     ) {
  //       if (pkgId !== undefined && pkgId !== null) {
  //         this.setState({ ...(this.state.SOL[id].packages = updatedPackages) });
  //       } else {
  //         this.setState({ totalWeight: this.state.totalWeight + Item.weight });
  //         this.setState({
  //           ...(this.state.SOL[id].updateDate = new Date()),
  //           ...(this.state.SOL[id].weight =
  //             this.state.SOL[id].weight + Item.weight),
  //           // ...(this.state.SOL[id].totalWeight = (this.state.SOL[id].qty + Free )*(Item.fixed_price)),
  //         });
  //       }
  //     } else {
  //       this.setState({ totalWeight: this.state.totalWeight + Item.weight });
  //       this.setState({
  //         ...(this.state.SOL[id].packages = updatedPackages),

  //         ...(this.state.SOL[id].updateDate = new Date()),
  //         ...(this.state.SOL[id].weight =
  //           this.state.SOL[id].weight + Item.weight),
  //         // ...(this.state.SOL[id].totalWeight = (this.state.SOL[id].qty + Free )*(Item.fixed_price)),
  //       });
  //     }
  //     // this.setState({ ...(this.state.SOL[id].uom = uom) });
  //   } else {
  //     this.setState({ ...(this.state.SOL[id] = {}) });
  //     var name =
  //       (Item.default_code !== false ? "[" + Item.default_code + "] " : "") +
  //       Item.name +
  //       " ";

  //     if (this.state.SOL[id].packages === undefined) {
  //       newPackage = {
  //         packageId: pkgId,
  //         PackageQty: pkgQty,
  //         qty: 1,
  //         // Add any other fields you need here
  //       };
  //     } else if (this.state.SOL[id].packages !== undefined) {
  //       newPackage = {
  //         packageId: pkgId,
  //         PackageQty: pkgQty,
  //         qty: (Number(this.state.SOL[id]?.packages?.[pkgId]?.qty) || 0) + 1,
  //         // Add any other fields you need here
  //       };
  //     }
  //     const updatedPackages = {
  //       ...(this.state.SOL[id]?.packages || {}),
  //       [pkgId]: newPackage,
  //     };
  //     // const Free = this.state.SOL[id].freeItem === undefined || this.state.SOL[id].freeItem === null ? 0 : this.state.SOL[id].freeItem ;
  //     this.setState({ totalWeight: this.state.totalWeight + Item.weight });
  //     await this.setState({
  //       ...(this.state.SOL[id].packages = updatedPackages),

  //       ...(this.state.SOL[id].id = id),
  //       ...(this.state.SOL[id].name = name),
  //       ...(this.state.SOL[id].productId = Item.id),
  //       ...(this.state.SOL[id].creationDate = new Date()),
  //       ...(this.state.SOL[id].weight = Item.weight),
  //       // ...(this.state.SOL[id].totalWeight = (this.state.SOL[id].qty + Free )*(Item.fixed_price)),
  //     });
  //     // this.setState({ ...(this.state.SOL[id].uom = uom) });
  //   }
  //   await this.calculateQuantities(Item.id, pkgId);
  //   await this.state.items.map(async (item) => {
  //     if (
  //       this.state.SOL[id] !== undefined &&
  //       this.state.SOL[id] !== null &&
  //       this.state.SOL[id].qty !== undefined &&
  //       this.state.SOL[id].qty !== null &&
  //       this.state.SOL[id].qty >= 0 &&
  //       (this.state.SOL[id].disc === undefined ||
  //         this.state.SOL[id].disc ===
  //           this.state.selectedClientDetails.fixed_discount)
  //     ) {
  //       await this.setState({
  //         ...(this.state.SOL[id].disc =
  //           this.state.selectedClientDetails.fixed_discount),
  //       });
  //     }
  //   });
  //   let lstPrice;

  //   if (pkgQty !== undefined && pkgQty !== null) {
  //     lstPrice = Item.fixed_price === undefined ? 0 : Item.fixed_price;
  //   }

  //   await this.setPrices(lstPrice, id, Item.taxes_id, this.state.SOL[id].qty);
  //   await this.calculateUntaxedAmount();
  //   await this.calculateTax();
  //   await this.calculateTaxedAmount();
  //   await this.calculateAndSetTotalLines(Item.id, Item.name);
  //   await this.productPromotion(id, Item);

  //   // await this.onChangeGlobalDiscount();
  // };

  calculateQuantities = (id, pkgId) => {
    if (
      this.state.SOL[id] !== undefined &&
      this.state.SOL[id] !== null &&
      this.state.SOL[id].packages !== undefined &&
      this.state.SOL[id].packages !== null &&
      this.state.SOL[id].packages[pkgId] !== undefined &&
      this.state.SOL[id].packages[pkgId] !== null
    ) {
      const sum = Object.values(this.state.SOL[id]?.packages || {})
        .filter((pkg) => pkg && pkg.qty && pkg.PackageQty) // Skip null/undefined or incomplete packages
        .reduce((total, pkg) => total + pkg.qty * pkg.PackageQty, 0);
      this.setState({ ...(this.state.SOL[id].qty = sum) });
    }
  };

  dicrementQty = async (id, Item, pkgQty, pkgId) => {
    let newPackage = null;
    if (this.state.SOL[id] !== undefined && this.state.SOL[id] !== null) {
      if (this.state.SOL[id].qty === 1) {
        this.state.SOL[id].disc = 0;
        this.state.SOL[id].discAmount = 0;
      }
      // const Free = this.state.SOL[id].freeItem === undefined || this.state.SOL[id].freeItem === null ? 0 : this.state.SOL[id].freeItem ;
      if (this.state.SOL[id].qty > 0) {
        if (
          this.state.SOL[id].packages !== undefined &&
          this.state.SOL[id]?.packages?.[pkgId]?.qty !== null &&
          this.state.SOL[id]?.packages?.[pkgId]?.qty > 0
        ) {
          newPackage = {
            packageId: pkgId,
            PackageQty: pkgQty,
            qty: (this.state.SOL[id]?.packages?.[pkgId]?.qty || 0) - 1,
            // Add any other fields you need here
          };
        }
        const updatedPackages = {
          ...(this.state.SOL[id]?.packages || {}),
          [pkgId]: newPackage,
        };
        this.setState({ totalWeight: this.state.totalWeight - Item.weight });
        this.setState({
          ...(this.state.SOL[id].packages = updatedPackages),
          ...(this.state.SOL[id].updateDate = new Date()),
          ...(this.state.SOL[id].weight =
            this.state.SOL[id].weight - Item.weight),
          // ...(this.state.SOL[id].totalWeight = (this.state.SOL[id].qty + Free)*(Item.fixed_price)),
        });
      }
      this.setState((prev) => {
        const SOL = [...prev.SOL];
        const current = SOL[id] || {};

        const qty = Number(current.qty || 0);
        const disc = Number(current.disc || 0);
        const price = Number(Item.fixed_price || 0);

        const discAmount = qty > 0 && disc > 0 ? price * qty * (disc / 100) : 0;

        SOL[id] = {
          ...current,
          discAmount,
        };

        return { SOL };
      });
    }
    await this.calculateQuantities(Item.id, pkgId);
    if (this.state.SOL[id] !== undefined && this.state.SOL[id] !== null) {
      let lstPrice;

      if (pkgQty !== undefined && pkgQty !== null) {
        lstPrice = Item.fixed_price === undefined ? 0 : Item.fixed_price;
      }
      await this.setPrices(lstPrice, id, Item.taxes_id, this.state.SOL[id].qty);
      await this.calculateUntaxedAmount();
      await this.calculateTax();
      await this.calculateTaxedAmount();
      await this.calculateAndSetTotalLines(Item.id, Item.name);
      await this.productPromotion(id, Item);
      // await this.onChangeGlobalDiscount();
    }
  };

  incrementfree = async (id, Item) => {
    if (this.state.SOL[id] !== undefined && this.state.SOL[id] !== null) {
      // const quantity = this.state.SOL[id].qty === undefined || this.state.SOL[id].qty === null ? 0 : this.state.SOL[id].qty;
      if (
        this.state.SOL[id].freeItem !== undefined &&
        this.state.SOL[id].freeItem !== null
      ) {
        this.setState({ totalWeight: this.state.totalWeight + Item.weight });
        this.setState({
          ...(this.state.SOL[id].freeItem =
            Number(this.state.SOL[id].freeItem) + 1),
          ...(this.state.SOL[id].updateDate = new Date()),
          ...(this.state.SOL[id].weight =
            this.state.SOL[id].weight + Item.weight),
          // ...(this.state.SOL[id].totalWeight = (quantity + this.state.SOL[id].freeItem)*(Item.fixed_price))
        });
      } else {
        this.setState({ totalWeight: this.state.totalWeight + Item.weight });
        this.setState({
          ...(this.state.SOL[id].freeItem = 1),
          ...(this.state.SOL[id].updateDate = new Date()),
          ...(this.state.SOL[id].unitPrice = Item.fixed_price),
          ...(this.state.SOL[id].weight =
            this.state.SOL[id].weight + Item.weight),
          // ...(this.state.SOL[id].totalWeight = (quantity + this.state.SOL[id].freeItem)*(Item.fixed_price))
        });
      }
    } else {
      this.setState({ ...(this.state.SOL[id] = {}) });
      var name =
        (Item.default_code !== false ? "[" + Item.default_code + "] " : "") +
        Item.name +
        " ";
      this.setState({ totalWeight: this.state.totalWeight + Item.weight });
      // const quantity = this.state.SOL[id].qty === undefined || this.state.SOL[id].qty === null ? 0 : this.state.SOL[id].qty;
      await this.setState({
        ...(this.state.SOL[id].freeItem = 1),
        ...(this.state.SOL[id].uom_id = Item.uom_id[1]),
        ...(this.state.SOL[id].id = id),
        ...(this.state.SOL[id].name = name),
        ...(this.state.SOL[id].totalPriceGlobal = 0),
        ...(this.state.SOL[id].itemTaxGlobal = 0),
        ...(this.state.SOL[id].productId = Item.id),
        ...(this.state.SOL[id].creationDate = new Date()),
        ...(this.state.SOL[id].unitPrice = Item.fixed_price),
        ...(this.state.SOL[id].weight = Item.weight),
        // ...(this.state.SOL[id].totalWeight = (quantity + this.state.SOL[id].freeItem)*(Item.fixed_price))
      });
    }
    await this.calculateAndSetTotalLines(Item.id, Item.name);
  };

  dicrementfree = async (id, Item) => {
    if (this.state.SOL[id] !== undefined && this.state.SOL[id] !== null) {
      const quantity =
        this.state.SOL[id].qty === undefined || this.state.SOL[id].qty === null
          ? 0
          : this.state.SOL[id].qty;
      if (this.state.SOL[id].freeItem > 0) {
        this.setState({ totalWeight: this.state.totalWeight - Item.weight });
        this.setState({
          ...(this.state.SOL[id].freeItem = this.state.SOL[id].freeItem - 1),
          ...(this.state.SOL[id].updateDate = new Date()),
          ...(this.state.SOL[id].weight =
            this.state.SOL[id].weight - Item.weight),

          // ...(this.state.SOL[id].totalWeight = (quantity + this.state.SOL[id].freeItem)*(Item.fixed_price))
        });
      }
    }
    await this.calculateAndSetTotalLines(Item.id, Item.name);
  };
  incrementDiscAmount = async (id, Item) => {
    const qty = Number(this.state.SOL[id].qty ?? 0);
    if (this.state.SOL[id] !== undefined) {
      const currentAmount =
        this.state.SOL[id].discAmount !== undefined
          ? this.state.SOL[id].discAmount
          : 0; // Prevent amount > price

      const newAmount =
        Item.fixed_price !== undefined
          ? Math.min(currentAmount + 1, Item.fixed_price * qty)
          : currentAmount + 1;

      this.setState({
        ...(this.state.SOL[id].discAmount = newAmount),
        ...(this.state.SOL[id].disc = Item.fixed_price
          ? (newAmount / (Item.fixed_price * qty)) * 100
          : 0),
        ...(this.state.SOL[id].updateDate = new Date()),
      });
    } else {
      // Initialize item in SOL
      this.setState({ ...(this.state.SOL[id] = {}) });
      const name =
        (Item.default_code ? `[${Item.default_code}] ` : "") + Item.name;
      await this.setState({
        ...(this.state.SOL[id].discAmount = 1),
        ...(this.state.SOL[id].disc = Item.fixed_price
          ? (1 / (Item.fixed_price * qty)) * 100
          : 0),
        ...(this.state.SOL[id].id = id),
        ...(this.state.SOL[id].name = name),
        ...(this.state.SOL[id].productId = Item.id),
      });
    }

    const lstPrice = Item.fixed_price ?? 0;

    await this.setPrices(lstPrice, Item.id, Item.taxes_id, qty);
    await this.calculateUntaxedAmount();
    await this.calculateTax();
    await this.calculateTaxedAmount();
    await this.calculateAndSetTotalLines(Item.id, Item.name);
  };

  decrementDiscAmount = async (id, Item) => {
    if (this.state.SOL[id] !== undefined) {
      const currentAmount = this.state.SOL[id].discAmount ?? 0;
      //     const newAmount = currentAmount > 0 ? currentAmount - 1 : 0;
      const newAmount = Math.max(0, currentAmount - 1);
      const qty = Number(this.state.SOL[id].qty ?? 0);
      this.setState({
        ...(this.state.SOL[id].discAmount = newAmount),
        ...(this.state.SOL[id].disc = Item.fixed_price
          ? (newAmount / (Item.fixed_price * qty)) * 100
          : 0),
        ...(this.state.SOL[id].updateDate = new Date()),
      });

      const lstPrice = Item.fixed_price ?? 0;
      await this.setPrices(lstPrice, Item.id, Item.taxes_id, qty);
      await this.calculateUntaxedAmount();
      await this.calculateTax();
      await this.calculateTaxedAmount();
      await this.calculateAndSetTotalLines(Item.id, Item.name);
    }
  };

  onChangeDiscAmount =
    (index, taxId, productId, listPrice, Item) => async (e) => {
      const qty =
        this.state.SOL[index].qty !== undefined
          ? Number(this.state.SOL[index].qty)
          : 0;
      const lstPrice = listPrice ?? 0;

      let amount = Number(e.target.value);

      if (isNaN(amount)) amount = 0;

      // Prevent negative
      if (amount < 0) amount = 0;

      // Prevent amount > price
      if (amount > lstPrice * qty) amount = lstPrice;

      if (
        this.state.SOL[index] === undefined ||
        this.state.SOL[index] === null
      ) {
        this.setState({ ...(this.state.SOL[index] = {}) });
      }

      await this.setState({
        ...(this.state.SOL[index].discAmount = amount),

        // 🔥 FORMULA (inverse of % logic)
        ...(this.state.SOL[index].disc = lstPrice
          ? (amount / (lstPrice * qty)) * 100
          : 0),

        ...(this.state.SOL[index].id = index),
        ...(this.state.SOL[index].productId = index),
      });

      await this.setPrices(lstPrice, index, taxId, qty);
      await this.calculateUntaxedAmount();
      await this.calculateTax();
      await this.calculateTaxedAmount();
      await this.calculateAndSetTotalLines(Item.id, Item.name);
    };

  incrementDisc = async (id, Item) => {
    const qty =
      this.state.SOL[id].qty !== undefined ? Number(this.state.SOL[id].qty) : 0;
    if (this.state.SOL[id] !== undefined) {
      if (
        this.state.SOL[id].disc !== undefined &&
        this.state.SOL[id].disc !== null
      ) {
        if (this.state.SOL[id].disc < 100) {
          this.setState({
            ...(this.state.SOL[id].disc = this.state.SOL[id].disc + 1),
            ...(this.state.SOL[id].updateDate = new Date()),

            ...(this.state.SOL[id].discAmount = Item.fixed_price
              ? (this.state.SOL[id].disc / 100) * (Item.fixed_price * qty)
              : 0),
          });
        }
      } else {
        this.setState({
          ...(this.state.SOL[id].disc = 1),
          ...(this.state.SOL[id].updateDate = new Date()),

          ...(this.state.SOL[id].discAmount = Item.fixed_price
            ? (1 / 100) * (Item.fixed_price * qty)
            : 0),
        });
      }
    } else {
      this.setState({ ...(this.state.SOL[id] = {}) });
      var name =
        (Item.default_code !== false ? "[" + Item.default_code + "] " : "") +
        Item.name +
        " ";
      await this.setState({
        ...(this.state.SOL[id].disc = 1),
        ...(this.state.SOL[id].id = id),
        ...(this.state.SOL[id].name = name),
        ...(this.state.SOL[id].productId = Item.id),

        ...(this.state.SOL[id].discAmount = Item.fixed_price
          ? (1 / 100) * (Item.fixed_price * qty)
          : 0),
      });
    }
    const lstPrice = Item.fixed_price === undefined ? 0 : Item.fixed_price;

    await this.setPrices(lstPrice, Item.id, Item.taxes_id, qty);
    await this.calculateUntaxedAmount();
    await this.calculateTax();
    await this.calculateTaxedAmount();
    await this.calculateAndSetTotalLines(Item.id, Item.name);
    // await this.onChangeGlobalDiscount();
  };

  dicrementDisc = async (id, Item) => {
    const qty =
      this.state.SOL[id].qty !== undefined ? Number(this.state.SOL[id].qty) : 0;
    if (this.state.SOL[id] !== undefined) {
      if (this.state.SOL[id].disc > 0) {
        const newDisc = Math.max(0, this.state.SOL[id].disc - 1);
        this.setState({
          ...(this.state.SOL[id].disc = newDisc),

          ...(this.state.SOL[id].discAmount = Item.fixed_price
            ? (newDisc / 100) * (Item.fixed_price * qty)
            : 0),
        });
      }
    }
    if (this.state.SOL[id] !== undefined) {
      const lstPrice = Item.fixed_price === undefined ? 0 : Item.fixed_price;

      await this.setPrices(lstPrice, Item.id, Item.taxes_id, qty);
      await this.calculateUntaxedAmount();
      await this.calculateTax();
      await this.calculateTaxedAmount();
      await this.calculateAndSetTotalLines(Item.id, Item.name);
      // await this.onChangeGlobalDiscount();
    }
  };
  /*  askcms*/
  showAlertimage = async (defaultCode, description) => {
    this.setState({
      showAlertimage: true,
      defaultCode: defaultCode,
      description: description,
    });
  };
  formatAmount = (value) => {
    const fixed = Number(this.state.fixed);

    // ensure fixed is between 0 and 20
    const safeFixed =
      Number.isInteger(fixed) && fixed >= 0 && fixed <= 20 ? fixed : 2;

    if (value == null || isNaN(value)) {
      return (0).toLocaleString("en-US", {
        minimumFractionDigits: safeFixed,
        maximumFractionDigits: safeFixed,
      });
    }

    return Number(value).toLocaleString("en-US", {
      minimumFractionDigits: safeFixed,
      maximumFractionDigits: safeFixed,
    });
  };

  handleChangeRemark = (event) => {
    this.setState({ inputValue: event.target.value });
  };

  closeAlertimage = () => {
    this.setState({ showAlertimage: false });
  };

  showAlertChange = async () => {
    this.setState({ showAlertChange: true });
  };

  showAlertPreview = async () => {
    this.setState({ showAlertPreview: true });
  };
  closeAlertPreview = () => {
    this.setState({ showAlertPreview: false });
  };

  showAlertRemark = async () => {
    this.setState({ showAlertRemark: true });
  };
  closeAlertRemark = () => {
    this.setState({ showAlertRemark: false });
  };

  showAlertImages = async () => {
    const d = new Date();
    d.setDate(d.getDate());
    console.log(d.getTime());

    this.setState({ showAlertImages: true, random: d.getTime() });
    await localStorage.setItem("random", JSON.stringify(this.state.random));
  };
  closeAlertImages = () => {
    this.setState({ showAlertImages: false });
  };

  showAlertCancel = async () => {
    this.setState({ showAlertCancel: true });
  };

  closeAlertCancel = () => {
    this.setState({ showAlertCancel: false });
  };

  showAlertCatalog = async () => {
    this.setState({ showAlertCatalog: true });
  };

  closeAlertCatalog = () => {
    this.setState({ showAlertCatalog: false });
  };

  clear = () => {
    this.sign.current.clear();
  };

  print = () => {
    window.print();
  };

  save = () => {
    this.setState({ data: this.sign.current.toDataURL() });
  };

  show = async () => {
    await this.sign.current.fromDataURL(this.state.data);
  };

  checkSignature = () => {
    this.setState({ checkSignature: true });
  };

  closeAlertChange = () => {
    this.setState({ showAlertChange: false });
  };

  onNextCatalog = async () => {
    this.setState({ loading: true });
    await this.state.catalogs.map(async (item, index) => {
      if (index + 1 < this.state.catalogs.length) {
        if (item.id === this.state.catalogId) {
          await this.setState({
            catalogId: this.state.catalogs[index + 1].id,
            countC: this.state.countC + 1,
            countP: 1,
          });
          var nextCategItems = [];
          await this.state.allitems.forEach((item) => {
            if (item.categ_id[0] === this.state.catalogId) {
              nextCategItems.push(item);
            }
            this.setState({ items: nextCategItems, itemsCopy: nextCategItems });
          });
          if (this.state.items.length === 0) {
            this.setState({ ofproducts: 1 });
          } else {
            this.setState({
              ofproducts: Math.round(this.state.items.length / 8) + 1,
            });
          }
        }
      }
    });
    this.setState({ offset: 0, offsetFixed: 0, countP: 1 });
    await this.setState({ loading: false });
    window.scrollTo(0, 0);
  };

  onPreviousCatalog = async () => {
    await this.setState({ loading: true });
    await this.state.catalogs.map(async (item, index) => {
      if (index - 1 >= 0) {
        if (item.id === this.state.catalogId) {
          await this.setState({
            catalogId: this.state.catalogs[index - 1].id,
            countC: this.state.countC - 1,
            countP: 1,
          });
          if (index - 1 === 0) {
            this.setState({
              items: this.state.allitems,
              itemsCopy: this.state.allitems,
            });
          } else {
            var prevCategItems = [];
            await this.state.allitems.forEach(async (item) => {
              if (item.categ_id[0] === this.state.catalogId) {
                prevCategItems.push(item);
              }
              await this.setState({
                items: prevCategItems,
                itemsCopy: prevCategItems,
              });
            });
          }
          if (this.state.items.length === 0) {
            this.setState({ ofproducts: 1 });
          } else {
            this.setState({
              ofproducts: Math.round(this.state.items.length / 8) + 1,
            });
          }
        }
      }
    });
    await this.setState({ loading: false });
    window.scrollTo(0, 0);
  };

  onChangeQty =
    (index, listPrice, taxId, Item, weight, pkgQty, pkgId, discount) =>
    async (e) => {
      //var istrue = true;
      let newPackage = null;
      let lstPrice;

      if (pkgQty !== undefined && pkgQty !== null) {
        lstPrice = listPrice === undefined ? 0 : listPrice;
      }
      //if (productId === item.product_id[0]) {
      if (this.state.SOL[index] === undefined || this.state.SOL[index] === null)
        this.setState({ ...(this.state.SOL[index] = {}) });

      //if (Number(e.target.value) <= item.quantity) {
      // istrue = true
      var name =
        (Item.default_code !== false ? "[" + Item.default_code + "] " : "") +
        Item.name +
        " ";
      if (this.state.SOL[index].packages === undefined) {
        newPackage = {
          packageId: pkgId,
          PackageQty: pkgQty,
          qty: e.target.value,
          // Add any other fields you need here
        };
      } else if (this.state.SOL[index].packages !== undefined) {
        newPackage = {
          packageId: pkgId,
          PackageQty: pkgQty,
          qty: e.target.value,
          // Add any other fields you need here
        };
      }
      const updatedPackages = {
        ...(this.state.SOL[index]?.packages || {}),
        [pkgId]: newPackage,
      };
      const Free =
        this.state.SOL[index].freeItem === undefined ||
        this.state.SOL[index].freeItem === null
          ? 0
          : Number(this.state.SOL[index].freeItem);
      await this.setState({
        ...(this.state.SOL[index].packages = updatedPackages),
      });
      await this.setState({
        ...(this.state.SOL[index].id = index),
        ...(this.state.SOL[index].uom_id = Item.uom_id[1]),
        ...(this.state.SOL[index].name = name),
        ...(this.state.SOL[index].qty = Number(e.target.value)),
        ...(this.state.SOL[index].productId = Item.id),
        ...(this.state.SOL[index].weight =
          (Free + Number(this.state.SOL[index].qty)) * weight),
      });

      if (
        discount !== null &&
        discount !== undefined &&
        discount !== false &&
        discount !== "false"
      ) {
        this.state.SOL[index].disc = Number(discount);
      }

      if (Number(e.target.value) === 0) {
        await this.setState({
          ...(this.state.SOL[index].disc = undefined),
        });
      }

      // Update the qty of the specific item in the SOL array

      // Calculate the total weight based on all item quantities
      const newTotalWeight = this.state.SOL.filter(
        (item) => item !== null && item !== undefined,
      ).reduce((total, item) => total + (Number(item.qty) + Free) * weight, 0);

      // Update the state with the new SOL array and total weight
      this.setState({
        totalWeight: newTotalWeight,
      });
      await this.calculateQuantities(Item.id, pkgId);
      await this.state.items.map(async (item) => {
        if (
          this.state.SOL[index] !== undefined &&
          this.state.SOL[index] !== null &&
          this.state.SOL[index].qty !== undefined &&
          this.state.SOL[index].qty !== null &&
          this.state.SOL[index].qty >= 0 &&
          this.state.SOL[index].disc === undefined
        ) {
          await this.setState({
            ...(this.state.SOL[index].disc =
              this.state.selectedClientDetails.fixed_discount),
          });
        }
      });
      this.setState((prev) => {
        const SOL = [...prev.SOL];
        const current = SOL[index] || {};

        const qty = Number(current.qty || 0);
        const disc = Number(current.disc || 0);
        const price = Number(Item.fixed_price || 0);

        const discAmount = qty > 0 && disc > 0 ? price * qty * (disc / 100) : 0;

        SOL[index] = {
          ...current,
          discAmount,
        };

        return { SOL };
      });
      //  await this.setState({totalWeight : this.state.totalWeight + (this.state.SOL[index].qty * listPrice)})
      await this.setPrices(lstPrice, index, taxId, this.state.SOL[index].qty);
      await this.calculateUntaxedAmount();
      await this.calculateTax();
      await this.calculateTaxedAmount();
      await this.calculateAndSetTotalLines(index, Item.name);
      await this.productPromotion(index, Item);
      // await this.onChangeGlobalDiscount();
    };

  setPrices = async (lstPrice, index, taxId, qty) => {
    var result = [];
    await this.state.clients.map((client, index) => {
      if (client.id === this.state.selectedClient) {
        result.push(client);
      }
    });
    if (
      result[0].sale_type !== false &&
      result[0].sale_type !== null &&
      result[0].sale_type !== undefined
    ) {
      const matchedSalesType = this.state.SalesType.find(
        (type) => type.id === result[0].sale_type[0],
      );
      if (matchedSalesType.taxable === true) {
        if (this.state.isTTC) {
          //If item is taxable
          if (taxId.length !== 0) {
            //Get the amount of tax
            var itemTax = 0;
            await this.state.taxes.map((tax) => {
              if (taxId[0] === tax.id) itemTax = tax.amount;
            });
            await this.setState({
              ...(this.state.SOL[index].unitPrice =
                lstPrice / (1 + itemTax / 100)),
              ...(this.state.SOL[index].price = lstPrice),
            });
          }
          //If item is not taxable
          else {
            await this.setState({
              ...(this.state.SOL[index].unitPrice = lstPrice),
              ...(this.state.SOL[index].price = lstPrice),
            });
          }
        }
        //IF TTC is not included
        else {
          //Get the amount of tax
          var itemTax = 0;
          await this.state.taxes.map((tax) => {
            if (taxId[0] === tax.id) itemTax = tax.amount;
          });
          //If item is taxable
          if (taxId.length !== 0) {
            await this.setState({
              ...(this.state.SOL[index].unitPrice = lstPrice),
              ...(this.state.SOL[index].price = lstPrice * (1 + itemTax / 100)),
            });
          }
          //If item is not taxable
          else {
            await this.setState({
              ...(this.state.SOL[index].unitPrice = lstPrice),
              ...(this.state.SOL[index].price = lstPrice),
            });
          }
        }
      } else {
        await this.setState({
          ...(this.state.SOL[index].unitPrice = lstPrice),
          ...(this.state.SOL[index].price = lstPrice),
        });
      }
      //If TTC is included
    } else {
      const defaultMatched = this.state.SalesType.find(
        (type) =>
          type.is_default === true &&
          ((type.sale_order_type === "sale" && this.state.type === 0) ||
            (type.sale_order_type === "return" && this.state.type === 1) ||
            (type.sale_order_type === "cash" && this.state.type === 5)),
      );
      if (
        defaultMatched !== undefined &&
        defaultMatched !== null &&
        defaultMatched.taxable === true
      ) {
        if (this.state.isTTC) {
          //If item is taxable
          if (taxId.length !== 0) {
            //Get the amount of tax
            var itemTax = 0;
            await this.state.taxes.map((tax) => {
              if (taxId[0] === tax.id) itemTax = tax.amount;
            });
            await this.setState({
              ...(this.state.SOL[index].unitPrice =
                lstPrice / (1 + itemTax / 100)),
              ...(this.state.SOL[index].price = lstPrice),
              ...(this.state.SOL[index].fixedprice = lstPrice),
            });
          }
          //If item is not taxable
          else {
            await this.setState({
              ...(this.state.SOL[index].unitPrice = lstPrice),
              ...(this.state.SOL[index].price = lstPrice),
              ...(this.state.SOL[index].fixedprice = lstPrice),
            });
          }
        }
        //IF TTC is not included
        else {
          //Get the amount of tax
          var itemTax = 0;
          await this.state.taxes.map((tax) => {
            if (taxId[0] === tax.id) itemTax = tax.amount;
          });
          //If item is taxable
          if (taxId.length !== 0) {
            await this.setState({
              ...(this.state.SOL[index].unitPrice = lstPrice),
              ...(this.state.SOL[index].price = lstPrice * (1 + itemTax / 100)),
              ...(this.state.SOL[index].fixedprice = lstPrice),
            });
          }
          //If item is not taxable
          else {
            await this.setState({
              ...(this.state.SOL[index].unitPrice = lstPrice),
              ...(this.state.SOL[index].price = lstPrice),
              ...(this.state.SOL[index].fixedprice = lstPrice),
            });
          }
        }
      } else {
        await this.setState({
          ...(this.state.SOL[index].unitPrice = lstPrice),
          ...(this.state.SOL[index].price = lstPrice),
          ...(this.state.SOL[index].fixedprice = lstPrice),
        });
      }
    }
    await this.setState({
      ...(this.state.SOL[index].netTotal =
        this.state.SOL[index].price *
        (1 -
          (this.state.SOL[index].disc ? this.state.SOL[index].disc : 0) / 100)),
      ...(this.state.SOL[index].netTotalUntaxed =
        this.state.SOL[index].unitPrice *
        (1 -
          (this.state.SOL[index].disc ? this.state.SOL[index].disc : 0) / 100)),
      ...(this.state.SOL[index].totalPrice =
        qty * this.state.SOL[index].netTotal),
      ...(this.state.SOL[index].totalPriceUntaxed =
        qty * this.state.SOL[index].netTotalUntaxed),
      ...(this.state.SOL[index].totalPriceGlobal =
        Number(this.state.globalDiscount) !== 0
          ? this.state.SOL[index].totalPrice *
            (1 - Number(this.state.globalDiscount) / 100)
          : this.state.SOL[index].totalPrice),
      ...(this.state.SOL[index].totalPriceUntaxedGlobal =
        Number(this.state.globalDiscount) !== 0
          ? this.state.SOL[index].totalPriceUntaxed *
            (1 - Number(this.state.globalDiscount) / 100)
          : this.state.SOL[index].totalPriceUntaxed),
      ...(this.state.SOL[index].itemTax =
        Math.abs(
          this.state.SOL[index].netTotalUntaxed -
            this.state.SOL[index].netTotal,
        ) * qty),
      ...(this.state.SOL[index].itemTaxGlobal =
        Number(this.state.globalDiscount) !== 0
          ? this.state.SOL[index].itemTax *
            (1 - Number(this.state.globalDiscount) / 100)
          : this.state.SOL[index].itemTax),
    });
  };

  quantity = (index) => {
    if (this.state.SOL[index] === undefined || this.state.SOL[index] === null)
      return "";
    else if (this.state.SOL[index].qty === undefined) return "";
    else return this.state.SOL[index].qty;
  };

  calculateAndSetTotalLines = (id, name) => {
    if (this.state.SOL !== null && this.state.SOL !== undefined) {
      const validSOL = Array.isArray(this.state.SOL)
        ? this.state.SOL.filter((so) => so !== null && so !== undefined)
        : [];

      const total = validSOL.reduce((sum, so) => {
        if (so.productId === id) {
          return sum + (so.totalPrice || 0);
        }
        return sum;
      }, 0);
      if (this.state.SOL[id] !== undefined && this.state.SOL[id] !== null) {
        this.setState({ ...(this.state.SOL[id].alltotallines = total) });
      } else {
        this.setState({ ...(this.state.SOL[id] = {}) });
        this.setState({
          ...(this.state.SOL[id].alltotallines = total),
          ...(this.state.SOL[id].name = name),
          ...(this.state.SOL[id].id = id),
          ...(this.state.SOL[id].productId = id),
        });
      }
    } else {
      this.setState({ ...(this.state.SOL[id].alltotallines = 0) });
    }
  };

  onChangeDescrip = (id, index, productId, item) => (e) => {
    if (this.state.SOL[id] === undefined || this.state.SOL[id] === null)
      this.setState({ ...(this.state.SOL[id] = {}) });
    var name =
      (item.default_code !== false ? "[" + item.default_code + "] " : "") +
      item.name +
      " ";
    this.setState({
      ...(this.state.SOL[id].descrip = e.target.value),
      ...(this.state.SOL[id].id = id),
      ...(this.state.SOL[id].name = name + e.target.value),
      ...(this.state.SOL[id].productId = productId),
    });
  };

  descrip = (index) => {
    if (this.state.SOL[index] === undefined || this.state.SOL[index] === null)
      return "";
    else if (this.state.SOL[index].descrip === undefined) return "";
    else return this.state.SOL[index].descrip;
  };

  onChangeFreeItems = (id, listPrice, Item, weight) => async (e) => {
    if (this.state.SOL[id] === undefined || this.state.SOL[id] === null)
      this.setState({ ...(this.state.SOL[id] = {}) });
    var name =
      (Item.default_code !== false ? "[" + Item.default_code + "] " : "") +
      Item.name +
      " ";
    const quantity =
      this.state.SOL[id].qty === undefined || this.state.SOL[id].qty === null
        ? 0
        : Number(this.state.SOL[id].qty);
    this.setState({
      ...(this.state.SOL[id].freeItem = Number(e.target.value)),
      ...(this.state.SOL[id].id = id),
      ...(this.state.SOL[id].uom_id = Item.uom_id[1]),
      ...(this.state.SOL[id].productId = Item.id),
      ...(this.state.SOL[id].name = name),
      ...(this.state.SOL[id].unitPrice = Item.fixed_price),
      ...(this.state.SOL[id].weight =
        (quantity + Number(this.state.SOL[id].freeItem)) * weight),
    });

    const newTotalWeight = this.state.SOL.filter(
      (item) => item !== null,
    ).reduce(
      (total, item) => total + (quantity + Number(item.freeItem)) * weight,
      0,
    );

    // Update the state with the new SOL array and total weight
    this.setState({
      totalWeight: newTotalWeight,
    });
    await this.calculateAndSetTotalLines(Item.id, Item.name);
  };

  freeItem = (index) => {
    if (this.state.SOL[index] === undefined || this.state.SOL[index] === null)
      return "";
    else if (this.state.SOL[index].freeItem === undefined) return "";
    else return this.state.SOL[index].freeItem;
  };

  onChangeReturnValue = (id, defaultCode, name, productId) => async (e) => {
    var isValid = false;
    var value = 0;
    if (e.target.value === "") {
      value = 0;
    } else {
      value = Number(e.target.value);
    }
    await this.state.remainingEmpty.map((item, index) => {
      if (value <= item.stock) {
        if (defaultCode === item.default_code) {
          isValid = true;
          if (this.state.SOL[id] === undefined || this.state.SOL[id] === null)
            this.setState({ ...(this.state.SOL[id] = {}) });
          this.setState({
            ...(this.state.SOL[id].returnValue = e.target.value),
            ...(this.state.SOL[id].id = id),
            ...(this.state.remainingEmpty[index].returnValue = Number(
              e.target.value,
            )),
            ...(this.state.SOL[id].default_code = defaultCode),
            ...(this.state.SOL[id].productName = name),
            ...(this.state.SOL[id].productId = productId),
          });
        }
      }
    });
    if (!isValid) {
      alert(
        "The entered return value is greater than the actual remaining value. Please enter a valid number.",
      );
    }
  };

  returnValue = (index) => {
    if (this.state.SOL[index] === undefined || this.state.SOL[index] === null)
      return "";
    else if (this.state.SOL[index].returnValue === undefined) return "";
    else return this.state.SOL[index].returnValue;
  };

  onChangeDisc = (index, taxId, productId, listPrice, Item) => async (e) => {
    const qty =
      this.state.SOL[index].qty !== undefined
        ? Number(this.state.SOL[index].qty)
        : 0;
    if (Number(e.target.value) <= 100) {
      const lstPrice = listPrice === undefined ? 0 : listPrice;
      if (this.state.SOL[index] === undefined || this.state.SOL[index] === null)
        this.setState({ ...(this.state.SOL[index] = {}) });
      await this.setState({
        ...(this.state.SOL[index].disc =
          Number(e.target.value) !== 0 ? Number(e.target.value) : ""),
        ...(this.state.SOL[index].id = index),
        ...(this.state.SOL[index].productId = index),

        ...(this.state.SOL[index].discAmount =
          Number(e.target.value) && lstPrice
            ? (Number(e.target.value) / 100) * (lstPrice * qty)
            : 0),
      });

      await this.setPrices(lstPrice, index, taxId, qty);
      await this.calculateUntaxedAmount();
      await this.calculateTax();
      await this.calculateTaxedAmount();
      await this.calculateAndSetTotalLines(Item.id, Item.name);
    }
  };

  calculateUntaxedAmount = async () => {
    var total = 0;
    await this.state.SOL.map((SOL, index) => {
      if (
        SOL !== undefined &&
        SOL !== null &&
        SOL.totalPriceUntaxedGlobal !== null &&
        SOL.totalPriceUntaxedGlobal !== undefined
      ) {
        total += Number(SOL.totalPriceUntaxedGlobal);
      }
    });
    await this.setState({ totalOrderPriceUntaxed: total });
  };

  calculateTaxedAmount = async () => {
    var total = 0;
    await this.state.SOL.map((SOL, index) => {
      if (
        SOL !== undefined &&
        SOL !== null &&
        SOL.totalPriceGlobal !== null &&
        SOL.totalPriceGlobal !== undefined
      ) {
        total += SOL.totalPriceGlobal;
      }
    });

    await this.setState({ totalOrderPriceTaxed: total });
  };

  calculateTax = async () => {
    var total = 0;
    await this.state.SOL.map((SOL, index) => {
      if (
        SOL !== undefined &&
        SOL !== null &&
        SOL.itemTaxGlobal !== null &&
        SOL.itemTaxGlobal !== undefined
      ) {
        total += Number(SOL.itemTaxGlobal);
      }
    });
    await this.setState({ totalVAT: total });
  };

  disc = (index) => {
    if (this.state.SOL[index] === undefined || this.state.SOL[index] === null)
      return "";
    else if (this.state.SOL[index].disc === undefined) return "";
    else return this.state.SOL[index].disc;
  };

  onChangeRemark = (index) => (e) => {
    if (this.state.SOL[index] === undefined || this.state.SOL[index] === null)
      this.setState({ ...(this.state.SOL[index] = {}) });
    this.setState({
      ...(this.state.SOL[index].remark = e.target.value),
      ...(this.state.SOL[index].id = index),
    });
  };

  onChangeGlobalDiscount = async (e) => {
    const showCustomerBalance = this.state.settingArray.some(
      (st) => st.key === "CustomerDiscount" && st.value === "1",
    );

    if (showCustomerBalance) {
      await this.setState({
        globalDiscount: this.state.selectedClientDetails.fixed_discount,
      });
    }

    await this.state.items.map(async (item, index) => {
      if (
        this.state.SOL[item.id] !== undefined &&
        this.state.SOL[item.id] !== null
      ) {
        await this.setPrices(
          item.fixed_price,
          item.id,
          item.taxes_id,
          this.state.SOL[item.id].qty !== undefined
            ? this.state.SOL[item.id].qty
            : 0,
        );
        await this.calculateUntaxedAmount();
        await this.calculateTax();
        await this.calculateTaxedAmount();
      }
    });
  };

  remark = (index) => {
    if (this.state.SOL[index] === undefined || this.state.SOL[index] === null)
      return "";
    else if (this.state.SOL[index].remark === undefined) return "";
    else return this.state.SOL[index].remark;
  };

  onCancel = async () => {
    this.unblock();
    await this.stopInterval();
    await localStorage.setItem("SOL", JSON.stringify([]));
    localStorage.setItem("SaveSol", JSON.stringify([]));
    localStorage.setItem("SaveTotal", JSON.stringify(0));
    localStorage.setItem("TotalWeight", JSON.stringify(0));

    localStorage.setItem("isEdit", JSON.stringify(false));
    this.props.history.push(
      "./" + this.state.transactionTypes[this.state.currentType].name,
    );
  };

  onSearch = async (text) => {
    this.setState({ searchText: text });
    var values = await SearchFilterFunction(
      text,
      this.state.items,
      this.state.itemsCopy,
      this.state.noData,
    );
    this.setState({
      items: values.items,
      noData: values.noData,
      offset: 0,
      offsetFixed: 0,
      countP: 1,
    });
  };

  clearSearch = () => {
    this.setState({
      searchText: "", // reset input value
      items: this.state.itemsCopy, // return all items
      noData: false,
    });
  };

  onSearchDelivery = async (text) => {
    this.setState({ barcode: text.target.value });
  };

  searchItem = async () => {
    //If it is based on SO
    if (!this.state.isEmpty) {
      //Check if item is found
      var isFound = false;
      await this.state.items.map((item, index) => {
        if (
          this.state.barcode ===
          item.name.substring(
            item.name.indexOf("[") + 1,
            item.name.indexOf("]"),
          )
        ) {
          //Item found
          isFound = true;
          //If barcode was entered for the first time, set the qty to 1
          if (this.state.items[index].deliveredQty === undefined)
            this.setState({ ...(this.state.items[index].deliveredQty = 1) });
          //If barcode has been entered before, cumulate quantity
          else {
            //Check if the quantity entered is not bigger than the ordered quantity
            if (
              item.product_uom_qty >=
              this.state.items[index].deliveredQty + 1
            )
              this.setState({
                ...(this.state.items[index].deliveredQty =
                  this.state.items[index].deliveredQty + 1),
              });
            else
              alert(
                "The entered quantity is greater than the ordered quantity",
              );
          }
        }
      });
      //If item is not found
      if (!isFound) {
        alert("The entered barcode is not found.");
      }
      this.setState({ barcode: "" });
    }
    //If not based on SO
    else {
      var temp = this.state.items;
      var itemFound = false;
      //Search for this item and add it with delivered qty
      await this.state.allitems.map(async (item) => {
        if (
          item.item.name.substring(
            item.name.indexOf("[") + 1,
            item.name.indexOf("]"),
          ) === this.state.barcode
        ) {
          itemFound = true;
          if (item.deliveredQty === undefined) {
            item.deliveredQty = 1;
          } else {
            item.deliveredQty = item.deliveredQty + 1;
          }
          const isFound = temp.find((x) => x.id === item.id);
          if (!isFound) temp.push(item);
        }
      });
      //If item is not found
      if (!itemFound) {
        alert("The entered barcode is not found.");
      }
      this.setState({ items: temp, barcode: "" });
    }
  };

  //Sets the delivered quanitity to the entered quantity
  onChangeQtyDelivery = (index) => async (e) => {
    //If based on SO
    if (!this.state.isEmpty) {
      const result = await this.checkQuantity(index, Number(e.target.value));
      if (result !== false) {
        this.setState({ ...(this.state.items[index].deliveredQty = result) });
      } else {
        alert("The entered quantity is greater than the ordered quantity");
      }
    }
    //If not based on SO
    else {
      var result = "";
      if (e.target.value !== "") {
        result = Number(e.target.value);
      }
      this.setState({ ...(this.state.items[index].deliveredQty = result) });
    }
  };

  //checks if the entered quantity is greater than the ordered quantity
  checkQuantity = async (index, qty) => {
    var result = false;
    await this.state.items.map((item, itemIndex) => {
      if (index === itemIndex) {
        if (item.product_uom_qty >= qty) {
          result = qty;
        } else {
          result = false;
        }
      }
    });
    return result;
  };

  saveOnline = async (createSO) => {
    this.unblock();
    if (this.state.SOL.length === 0) {
      this.setState({ alertUndefined: true });
    } else {
      let image =
        "data:image/png;base64,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";
      if (this.state.data !== image) {
        //Create the body of the lines to send
        await localStorage.setItem("SOL", JSON.stringify(this.state.SOL));
        await localStorage.setItem(
          "Total",
          JSON.stringify(this.state.totalOrderPriceTaxed),
        );
        var tempBody = {
          lines: [],
        };
        await this.state.SOL.map(async (item, index, arr) => {
          if (item.qty !== 0 && item.qty !== "" && item.qty !== undefined) {
            var tempItem = {};
            var qty = this.state.currentType === 1 ? item.qty * -1 : item.qty;

            tempItem.productId = item.productId;
            tempItem.qty = qty;
            if (item.disc) {
              tempItem.discount = Number(item.disc);
            }
            tempBody.lines.push(tempItem);

            if (item.freeItem !== undefined) {
              if (Number(item.freeItem) !== 0) {
                var tempFreeItem = {};
                tempFreeItem.productId = item.productId;
                tempFreeItem.qty = item.freeItem;
                tempFreeItem.discount = 100;

                tempBody.lines.push(tempFreeItem);
              }
            }
          }
        });
        console.log(createSO);
        console.log(JSON.stringify(tempBody));
        //Create the transaction with its lines (in body)
        await _postBody(createSO, tempBody).then((response) => {
          return response.json().then((data) => {
            console.log(data);
            if (data.result !== undefined) {
              console.log(data);
              this.setState({ SOId: data.result.results[0].recordID });
            } else {
              this.setState({ alertUndefined: true });
            }
          });
        });

        const updateSignature =
          constantURI() +
          this.state.transactionTypes[this.state.currentType].signature +
          this.state.token +
          "&user=" +
          this.state.username +
          "&id=" +
          this.state.SOId;
        var body = {};
        body.signature = this.state.data.substring(22);
        console.log(JSON.stringify(body));
        console.log(updateSignature);
        await _postBody(updateSignature, body);
        this.props.history.push("/Print");
      } else {
        alert("no signature");
        this.setState({ alertUndefined: true });
      }
    }
  };

  saveOnlineDelivery = async () => {
    this.unblock();
    //If based on SO, check if all ordered items are delivered
    if (!this.state.isEmpty) {
      var notDone = false;
      await this.state.items.map((item) => {
        if (item.product_uom_qty !== item.deliveredQty && !notDone) {
          notDone = true;
        }
      });
      if (notDone) {
        alert(
          "The delivered quantities are not compatibile with the ordered quantities",
        );
        this.setState({ loading: false });
      } else {
        await this.confirm();
      }
    } else {
      var uuid = uuidv4();
      const createSO =
        constantURI() +
        this.state.transactionTypes[this.state.currentType].SOs +
        this.state.token +
        "&user=" +
        this.state.username +
        "&name=" +
        this.state.transactionTypes[this.state.currentType].type +
        "-" +
        uuid +
        "&type=" +
        this.state.transactionTypes[this.state.currentType].type +
        "&partnerId=" +
        this.state.selectedClient +
        "&discount=" +
        Number(this.state.globalDiscount) +
        "&date=" +
        new Date().toISOString().substring(0, 10);
      var tempBody = {
        lines: [],
      };
      await this.state.items.map(async (item, index, arr) => {
        if (item.deliveredQty !== 0 && item.deliveredQty !== undefined) {
          var tempItem = {};
          tempItem.productId = item.productId;
          tempItem.qty = item.deliveredQty;
          tempBody.lines.push(tempItem);
        }
      });
      await ASAPAuthenticate().then((response) => {
        this.setState({ authenticate: response });
      });
      if (this.state.authenticate) {
        await _post(createSO, tempBody).then((response) => {
          return response.json().then((data) => {
            if (data.result !== undefined) {
              this.setState({ SOId: data.result });
              this.props.history.push(
                "./" + this.state.transactionTypes[this.state.currentType].name,
              );
            } else {
              this.setState({ alertUndefined: true });
            }
          });
        });
        const updateSignature =
          constantURI() +
          this.state.transactionTypes[this.state.currentType].signature +
          this.state.token +
          "&user=" +
          this.state.username +
          "&id=" +
          this.state.SOId;
        var body = {};
        body.signature = this.state.data.substring(22);
        await _postBody(updateSignature, body);
      } else {
        await this.saveOfflineDelivery(createSO, true);
      }
    }
  };

  saveOffline = async (createSO) => {
    this.unblock();
    this.stopInterval();
    await localStorage.setItem("SaveSol", JSON.stringify([]));
    await localStorage.setItem("SaveTotal", JSON.stringify(0));
    await localStorage.setItem("TotalWeight", JSON.stringify(0));

    const d = new Date();
    d.setDate(d.getDate());
    await this.setState({
      SignatureDate: d.toISOString().substring(0, 10),
      SignatureTime: d.getHours() + d.toISOString().substring(13, 19),
    });
    localStorage.setItem(
      "SignatureDate",
      JSON.stringify(this.state.SignatureDate),
    );
    localStorage.setItem(
      "SignatureTime",
      JSON.stringify(this.state.SignatureTime),
    );
    localStorage.setItem(
      "Signature",
      JSON.stringify(this.state.data.substring(22)),
    );

    await localStorage.setItem("SOL", JSON.stringify(this.state.SOL));
    await localStorage.setItem(
      "Total",
      JSON.stringify(this.state.totalOrderPriceTaxed),
    );
    await localStorage.setItem("VAT", JSON.stringify(this.state.totalVAT));
    var uuid = uuidv4();
    var SOs = this.state.UST === null ? [] : this.state.UST;
    var dailyData = this.state.dailyData;
    if (
      dailyData[this.state.currentType] === undefined ||
      dailyData[this.state.currentType] === null
    ) {
      dailyData[this.state.currentType] = [];
    }
    //Define the header of the transaction
    var temp = {};
    const resolvedCurrency = localStorage.getItem("DefaultCurrencyName") ||
      (this.state.SelectedClientDetails?.currency_id &&
        Array.isArray(this.state.SelectedClientDetails.currency_id)
        ? this.state.SelectedClientDetails.currency_id
        : this.state.SelectedClientDetails?.currency_id &&
          typeof this.state.SelectedClientDetails.currency_id === "object"
          ? [this.state.SelectedClientDetails.currency_id.id, this.state.SelectedClientDetails.currency_id.name || this.state.SelectedClientDetails.currency_id.code]
          : null) ||
      (this.state.clientDetail?.currency_id &&
        Array.isArray(this.state.clientDetail.currency_id)
        ? this.state.clientDetail.currency_id
        : this.state.clientDetail?.currency_id &&
          typeof this.state.clientDetail.currency_id === "object"
          ? [this.state.clientDetail.currency_id.id, this.state.clientDetail.currency_id.name || this.state.clientDetail.currency_id.code]
          : null) ||
      (this.state.clientCurrency && Array.isArray(this.state.clientCurrency)
        ? this.state.clientCurrency
        : this.state.clientCurrency && typeof this.state.clientCurrency === "object"
          ? [this.state.clientCurrency.id, this.state.clientCurrency.name || this.state.clientCurrency.code]
          : null) ||
      null;

    temp.createURL = createSO;
    if (this.state.isEdit) temp.usId = Number(this.state.usId);
    else temp.usId = this.state.count;
    if (this.state.isEdit) temp.name = this.state.EditName;
    else
      temp.name =
        this.state.transactionTypes[this.state.currentType].LS +
        (this.state.count + 1);
    temp.amount_total = this.state.totalOrderPriceTaxed.toFixed(
      this.state.fixed,
    );
    if (this.state.currentType === 5 && resolvedCurrency) {
      temp.currency_id = resolvedCurrency;
    }
    temp.date_order = new Date().toISOString();
    temp.scheduling = this.state.isSchedule;
    temp.globalDiscount = Number(this.state.globalDiscount);
    temp.partner_id = [];
    temp.partner_id[0] = this.state.selectedClient;
    temp.partner_id[1] = this.state.selectedClientName;
    temp.untaxedAmount = this.numberWithCommas(
      this.state.totalOrderPriceUntaxed.toFixed(this.state.fixed),
    );
    temp.VAT = this.numberWithCommas(
      this.state.totalVAT.toFixed(this.state.fixed),
    );
    temp.taxedAmount = this.numberWithCommas(
      this.state.totalOrderPriceTaxed.toFixed(this.state.fixed),
    );
    temp.ischashinvoice = this.state.currentType === 5 ? true : false;
    temp.state = "Unsynced";
    temp.updateState = "Unsynced";
    temp.signatureUrl =
      constantURI() +
      this.state.transactionTypes[this.state.currentType].signature +
      this.state.token +
      "&user=" +
      this.state.username +
      "&id=" +
      uuid;
    temp.signature = this.state.data.substring(22);

    //Define the lines of the transaction
    temp.Lines = [];
    var tempBody = {
      lines: [],
    };
    if (this.state.currentType === 5 && resolvedCurrency) {
      tempBody.currency_id = resolvedCurrency;
      tempBody.invoice_currency_id = resolvedCurrency;
      tempBody.currency = resolvedCurrency;
    }

    var lineInfo = [];
    var Log = {};
    if (this.state.SOL.length !== 0) {
      const solFilter = this.state.SOL.filter((e) =>
        e !== null &&  e !== undefined
          ? (e.qty !== "" && e.qty !== 0 && e.qty !== undefined) ||
            (e.freeItem !== "" && e.freeItem !== 0 && e.freeItem !== undefined)
          : null,
      );
      console.log(solFilter);
      if (solFilter.length !== 0) {
        await solFilter.map(async (item, index, arr) => {
          if (
            (item.qty !== 0 &&
              item.qty !== "" &&
              item.qty !== undefined &&
              item.qty !== null) ||
            (this.state.SOL[item.id].packages !== undefined &&
              this.state.SOL[item.id].packages !== null)
          ) {
            const packages = this.state.SOL[item.id]?.packages || {};
            const packageArray = Object.values(packages).filter(
              (pack) => pack != null,
            );
            packageArray.map((pack) => {
              this.setState({ enter: false });
              var tempItem = {}; //The body to send to the api
              var tempLine = {}; //The details to use in details page
              var qty = this.state.currentType === 1 ? item.qty * -1 : item.qty;
              var freeItem =
                this.state.currentType === 1
                  ? item.freeItem * -1
                  : item.freeItem;

              tempLine.id = uuid;
              tempLine.uom_id = item.uom_id;
              tempLine.order_partner_id = [];
              tempLine.unitPrice = item.unitPrice;
              tempLine.price = item.price;
              tempLine.packages = packages;
              tempLine.order_partner_id[0] = this.state.selectedClient;
              tempLine.order_partner_id[1] = this.state.selectedClientName;
              tempLine.create_date = new Date().toISOString();
              tempLine.price_total = item.totalPrice;
              tempLine.totalPriceUntaxed = item.totalPriceUntaxed;
              tempLine.itemTax = item.itemTax;
              tempLine.product_id = item.productId;
              tempLine.productId = item.id;
              tempLine.fixedprice = item.fixedprice;
              tempLine.name = item.name;
              if (item.qty) tempLine.product_uom_qty = Number(qty);
              if (item.disc) {
                tempLine.discount = Number(item.disc);
              } else {
                tempLine.discount = 0.0;
              }
              if (item.descrip) tempLine.descrip = item.descrip;
              if (item.remark) tempLine.remark = item.remark;
              if (item.freeItem) tempLine.freeItem = Number(freeItem);

              tempItem.partnerId = this.state.selectedClient;
              tempItem.itemName = item.name;
              tempItem.productId = item.productId;
              tempItem.freeItem = freeItem;
              tempItem.price = item.fixedprice;
              if (pack.qty !== null && pack.qty !== undefined) {
                tempItem.qty = pack.qty;
              }
              if (pack.packageId !== 0) {
                tempItem.package_id = pack.packageId;
                tempItem.package_qty = pack.PackageQty;
              }

              if (item.disc) {
                tempItem.discount = Number(item.disc);
              } else {
                tempItem.discount = 0.0;
              }
              tempBody.lines.push(tempItem);

              if (item.freeItem !== undefined) {
                if (Number(item.freeItem) !== 0) {
                  var tempFreeItem = {};
                  tempFreeItem.partnerId = this.state.selectedClient;
                  tempFreeItem.itemName = item.name;
                  tempFreeItem.productId = item.id;
                  tempFreeItem.qty = Number(freeItem);
                  tempFreeItem.discount = 100;
                  tempFreeItem.price = item.fixedprice;
                  tempBody.lines.push(tempFreeItem);
                }
              }
              temp.Lines.push(tempLine);
            });
          } else if (item.freeItem !== undefined && item.freeItem !== null) {
            this.setState({ enter: false });
            var tempItem = {}; //The body to send to the api
            var tempLine = {}; //The details to use in details page

            tempLine.id = uuid;

            tempLine.order_partner_id = [];
            tempLine.order_partner_id[0] = this.state.selectedClient;
            tempLine.order_partner_id[1] = this.state.selectedClientName;
            tempLine.create_date = new Date().toISOString();
            tempLine.product_id = item.productId;
            tempLine.productId = item.id;
            tempLine.name = item.name;
            tempLine.uom_id = item.uom_id;
            if (item.freeItem) tempLine.freeItem = Number(item.freeItem);

            if (item.freeItem !== undefined) {
              if (Number(item.freeItem) !== 0) {
                var tempFreeItem = {};
                tempFreeItem.partnerId = this.state.selectedClient;
                tempFreeItem.itemName = item.name;
                tempFreeItem.productId = item.productId;
                tempFreeItem.price = item.fixedprice;
                tempFreeItem.qty = Number(item.freeItem);
                tempFreeItem.discount = 100;
                tempBody.lines.push(tempFreeItem);
              }
            }
            temp.Lines.push(tempLine);
          } else {
            alert("You don't have any ordered items. ");
            this.setState({ loading: false, enter: true });
          }
        });
        try {
          // Use 'get' method from idb-keyval to read SoLog from IndexedDB
          const data = await get("SoLog");
          if (data) {
            this.setState({ SoLog: data });
            console.log("SoLog from IndexedDB:", data);
          } else {
            console.log("SoLog not found in IndexedDB.");
            await set("SoLog", this.state.SoLog);
            console.log("SoLog added to IndexedDB successfully!");
          }
        } catch (error) {
          console.error("Error reading PriceList from IndexedDB:", error);
        }
        this.state.SOL.forEach((item, index) => {
          if (item !== null) {
            // Ensure the object exists at the given index
            if (!lineInfo[index]) {
              lineInfo[index] = {}; // Initialize object if it doesn't exist
            }
            // Assign the item directly to the object at the corresponding index
            lineInfo[index] = item; // Replace with the item itself or custom object if needed
          }
        });
        Log.lineInfo = lineInfo;
        Log.creationDate = new Date();
        Log.username = this.state.username;
        Log.id = uuid;
        Log.isSaved = true;
        Log.Clientname = this.state.SelectedClientName;
        Log.ClientId = this.state.SelectedClient;
        Log.type = this.state.transactionTypes[this.state.currentType].LS;
        await this.state.SoLog.push(Log);
        await set("SoLog", this.state.SoLog);
        const lastLog = this.state.SoLog[this.state.SoLog.length - 1];
        await this.state.lastLineInfo.push(lastLog);
        localStorage.setItem(
          "SoLogLastIndex",
          JSON.stringify(this.state.lastLineInfo),
        );
      } else {
        alert("You don't have any ordered items. ");
        this.setState({ loading: false, enter: true });
      }
      if (!this.state.enter) {
        temp.Body = tempBody;
        //If edit
        if (this.state.isEdit) {
          SOs[this.state.EditId] = temp;
          dailyData[this.state.currentType][this.state.EditId] = temp;
        }
        //If create
        else {
          //Set this transaction and the count in the local storage
          await SOs.push(temp);
          await dailyData[this.state.currentType].push(temp);
          const nextCount = this.state.count + 1;
          const localCount = [...(this.state.originalCount || [])];
          localCount[this.state.currentType] = nextCount;
          this.setState({ count: nextCount, originalCount: localCount });
          await localStorage.setItem(
            "UnsyncedTransactionsCount",
            JSON.stringify(localCount),
          );
        }

        const localSOs = this.state.originalTransactions;
        localSOs[this.state.currentType] = SOs;
        await localStorage.setItem(
          "UnsyncedTransactions",
          JSON.stringify(localSOs),
        );
        await localStorage.setItem("DailyData", JSON.stringify(dailyData));

        await this.DailySummaryReport();
        if (this.state.currentType !== 5) {
          await this.showPrint();
        } else {
          // Use the exact saved name so Payment and the route guard find this invoice.
          await localStorage.setItem("CurrentCashSales", JSON.stringify(temp.name));
          await localStorage.setItem("PendingCashInvoicePayment", JSON.stringify(true));
          this.props.history.push("/Payment");
        }
      }
    } else {
      alert("You don't have any ordered items. ");
      this.setState({ loading: false });
    }
    // temp.Body = tempBody;
    // //If edit
    // if (this.state.isEdit) {
    //     SOs[this.state.EditId] = temp;
    //     dailyData[this.state.currentType][this.state.EditId] = temp;
    // }
    // //If create
    // else {
    //     //Set this transaction and the count in the local storage
    //     await SOs.push(temp);
    //     await dailyData[this.state.currentType].push(temp);
    //     this.setState({count: this.state.count + 1});
    //     const localCount = this.state.originalCount;
    //     localCount[this.state.currentType] = this.state.count;
    //     await localStorage.setItem('UnsyncedTransactionsCount', JSON.stringify(localCount));
    // }

    // const localSOs = this.state.originalTransactions;
    // localSOs[this.state.currentType] = SOs;
    // await localStorage.setItem('UnsyncedTransactions', JSON.stringify(localSOs));
    // await localStorage.setItem('DailyData', JSON.stringify(dailyData));

    // await this.DailySummaryReport();

    // await this.showPrint();
  };

  DailySummaryReport = async () => {
    if (this.state.isSchedule !== 1) {
      this.state.dailySummaryReport[0].ordered++;
      this.state.dailySummaryReport[0].OOR++;
    } else {
      this.state.dailySummaryReport[0].ordered++;
    }
    await localStorage.setItem(
      "DailySummaryReport",
      JSON.stringify(this.state.dailySummaryReport),
    );
  };

  showPrint = () => {
    this.setState({ showPrint: true });
  };

  closePrint = () => {
    this.setState({ showPrint: false });
  };

  saveOfflineDelivery = async (URL, isNew) => {
    this.unblock();
    var SOs = this.state.UST === null ? [] : this.state.UST;
    var dailyData = this.state.dailyData;

    //Define the header of the transaction
    var temp = {};
    temp.createURL = URL;
    temp.usId = this.state.count;
    temp.name =
      this.state.transactionTypes[this.state.currentType].LS +
      (this.state.count + 1);
    temp.amount_total = this.state.totalOrderPriceTaxed.toFixed(
      this.state.fixed,
    );
    temp.date_order = new Date().toISOString();
    temp.globalDiscount = Number(this.state.globalDiscount);
    temp.partner_id = [];
    temp.partner_id[0] = this.state.selectedClient;
    temp.partner_id[1] = this.state.selectedClientName;
    temp.isVendor = this.state.isVendor;
    temp.state = "Unsynced";
    temp.updateState = "Unsynced";

    var uuid = uuidv4();

    if (!this.state.isEmpty) {
      temp.basedSO = true;
      temp.order = this.state.order;
      temp.signatureUrl =
        constantURI() +
        "updateDelivery?token=" +
        this.state.token +
        "&user=" +
        this.state.username +
        "&id=" +
        uuid;
    } else {
      temp.basedSO = false;
      temp.signatureUrl =
        constantURI() +
        this.state.transactionTypes[this.state.currentType].signature +
        this.state.token +
        "&user=" +
        this.state.username +
        "&id=" +
        uuid;
    }
    temp.signature = this.state.data.substring(22);

    //Define the lines of the transaction
    temp.Lines = [];
    var tempBody = {
      lines: [],
    };
    if (this.state.items.length !== 0) {
      await this.state.items.map((item) => {
        if (item !== undefined) {
          var tempLine = {};
          tempLine = item;
          tempLine.id = uuid;
          tempLine.product_uom_qty = item.deliveredQty;

          var tempItem = {};
          tempItem.productId = item.productId;
          tempItem.qty = item.deliveredQty;
          tempBody.lines.push(tempItem);

          temp.Lines.push(tempLine);
        }
      });
    }
    temp.Body = tempBody;
    //Set this transaction and the count in the local storage
    await SOs.push(temp);
    await dailyData[this.state.currentType].push(temp);
    const nextCount = this.state.count + 1;
    const localCount = [...(this.state.originalCount || [])];
    localCount[this.state.currentType] = nextCount;
    this.setState({ count: nextCount, originalCount: localCount });

    const localSOs = this.state.originalTransactions;
    localSOs[this.state.currentType] = SOs;

    await localStorage.setItem(
      "UnsyncedTransactionsCount",
      JSON.stringify(localCount),
    );
    await localStorage.setItem(
      "UnsyncedTransactions",
      JSON.stringify(localSOs),
    );
    await localStorage.setItem("DailyData", JSON.stringify(dailyData));
    this.props.history.push(
      "./" + this.state.transactionTypes[this.state.currentType].name,
    );
  };

  onSave = async () => {
    this.unblock();
    if (this.sign.current.isEmpty()) {
      alert(
        "Please sign this " +
          this.state.transactionTypes[this.state.currentType].name,
      );
    } else {
      await localStorage.setItem(
        "countTrans",
        JSON.stringify(this.state.countTrans + 1),
      );
      await localStorage.setItem("SOL", JSON.stringify(this.state.SOL));
      await localStorage.setItem(
        "Total",
        JSON.stringify(this.state.totalOrderPriceTaxed),
      );
      await localStorage.setItem("VAT", JSON.stringify(this.state.totalVAT));
      if (this.sign.current.toDataURL !== null) {
        this.setState({ data: this.sign.current.toDataURL() });
      }

      this.setState({ loading: true });
      //await ASAPAuthenticate().then((response) => { this.setState({ authenticate: response }) });

      const uuid = uuidv4();
      const now = new Date();
      var result = [];
      await this.state.clients.map((client, index) => {
        if (client.id === this.state.selectedClient) {
          result.push(client);
        }
      });
      const defaultMatched = this.state.SalesType.find(
        (type) =>
          type.is_default === true &&
          ((type.sale_order_type === "sale" && this.state.type === 0) ||
            (type.sale_order_type === "return" && this.state.type === 1) ||
            (type.sale_order_type === "cash" && this.state.type === 5)),
      );
      const defaultId = defaultMatched ? defaultMatched.name : null;
      const formatted =
        now.getFullYear() +
        "-" +
        String(now.getMonth() + 1).padStart(2, "0") +
        "-" +
        String(now.getDate()).padStart(2, "0") +
        " " +
        String(now.getHours()).padStart(2, "0") +
        ":" +
        String(now.getMinutes()).padStart(2, "0") +
        ":" +
        String(now.getSeconds()).padStart(2, "0");
      var createSO =
        constantURI() +
        this.state.transactionTypes[this.state.currentType].SOs +
        this.state.token +
        "&user=" +
        this.state.username +
        "&name=" +
        this.state.transactionTypes[this.state.currentType].type +
        "-" +
        uuid +
        "&type=" +
        this.state.transactionTypes[this.state.currentType].type +
        "&partnerId=" +
        this.state.selectedClient +
         "&selectedClientName=" +
        this.state.SelectedClientDetails.name +
        "&discount=" +
        Number(this.state.globalDiscount) +
        "&date=" +
        formatted +
        "&remark=" +
        this.state.inputValue +
        "&userId=" +
        this.state.UserId +
        "&saletype=" +
        (result[0].sale_type !== false &&
        result[0].sale_type !== null &&
        result[0].sale_type !== undefined
          ? result[0].sale_type[0]
          : defaultId);

      if (this.state.currentType === 5) createSO += "&isCashInvoice=true";

      localStorage.setItem("isEdit", JSON.stringify(false));

      //If Edit
      if (this.state.isEdit) {
        this.saveOffline(createSO);
      } else {
        //If transaction is not delivery
        if (this.state.currentType !== 4) {
          this.saveOffline(createSO);
        }
        //If transaction is delivery
        else {
          this.saveOfflineDelivery();
        }
      }
    }
  };

  confirm = async () => {
    var confirm =
      constantURI() +
      "Action?token=" +
      this.state.token +
      "&user=" +
      this.state.username +
      "&id=" +
      this.state.order.id +
      "&action=";
    if (this.state.isVendor) {
      confirm = confirm + "button_confirm" + "&table=" + "purchase.order";
    } else {
      confirm = confirm + "action_confirm" + "&table=" + "sale.order";
    }
    await ASAPAuthenticate().then((response) => {
      this.setState({ authenticate: response });
    });
    if (this.state.authenticate) {
      await _post(confirm);
      await this.getDelivery();
    } else {
      await this.saveOfflineDelivery(confirm, false);
    }
  };

  getDelivery = async () => {
    await ASAPAuthenticate().then((response) => {
      this.setState({ authenticate: response });
    });
    const getDelivery =
      constantURI() +
      "GetDelivery?token=" +
      this.state.token +
      "&user=" +
      this.state.username +
      "&source=" +
      this.state.order.name;
    if (this.state.authenticate) {
      await _post(getDelivery).then((response) => {
        return response.json().then(async (data) => {
          if (data.result !== undefined) {
            await this.setState({
              delivery: data.result,
              alertUndefined: false,
            });
            await this.checkAvailability();
          } else {
            this.setState({ alertUndefined: true });
          }
        });
      });
    } else {
      await this.saveOfflineDelivery(getDelivery, false);
    }
  };

  checkAvailability = async () => {
    const checkAvailability =
      constantURI() +
      "Action?token=" +
      this.state.token +
      "&user=" +
      this.state.username +
      "&action=" +
      "action_assign" +
      "&table=" +
      "stock.picking" +
      "&id=" +
      this.state.delivery[0].id;
    await ASAPAuthenticate().then((response) => {
      this.setState({ authenticate: response });
    });
    if (this.state.authenticate) {
      await _post(checkAvailability);
      this.setQuantities();
    } else {
      await this.saveOfflineDelivery(checkAvailability, false);
    }
  };

  setQuantities = async () => {
    const transfer =
      constantURI() +
      "Action?token=" +
      this.state.token +
      "&user=" +
      this.state.username +
      "&action=" +
      "action_set_quantities_to_reservation" +
      "&table=" +
      "stock.picking" +
      "&id=" +
      this.state.delivery[0].id;
    await ASAPAuthenticate().then((response) => {
      this.setState({ authenticate: response });
    });
    if (this.state.authenticate) {
      await _post(transfer);
      this.validate();
    } else {
      await this.saveOfflineDelivery(transfer, false);
    }
  };

  validate = async () => {
    const validate =
      constantURI() +
      "Action?token=" +
      this.state.token +
      "&user=" +
      this.state.username +
      "&action=" +
      "button_validate" +
      "&table=" +
      "stock.picking" +
      "&id=" +
      this.state.delivery[0].id;
    await ASAPAuthenticate().then((response) => {
      this.setState({ authenticate: response });
    });
    if (this.state.authenticate) {
      await _post(validate);
      const updateSignature =
        constantURI() +
        "updateDelivery?token=" +
        this.state.token +
        "&user=" +
        this.state.username +
        "&id=" +
        this.state.delivery[0].id;
      var body = {};
      body.signature = this.state.data.substring(22);
      await _postBody(updateSignature, body);
      this.props.history.push(
        "./" + this.state.transactionTypes[this.state.currentType].name,
      );
    } else {
      await this.saveOfflineDelivery(validate, false);
    }
  };

  numberWithCommas = (x) => {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  onGrid = () => {
    this.setState({ isGrid: true });
    localStorage.setItem("IsGrid", JSON.stringify(true));
  };

  onList = () => {
    this.setState({ isGrid: false });
    localStorage.setItem("IsGrid", JSON.stringify(false));
  };

  onFilter = async () => {
    await this.setState({ isFilter: !this.state.isFilter });
    if (this.state.isFilter) {
      this.setState({
        items: this.state.items.filter((e) =>
          this.state.SOL.some((s) => (s !== null && s !== undefined ? s.id === e.id : null)),
        ),
        offset: 0,
        offsetFixed: 0,
        countP: 1,
      });
    } else {
      this.setState({ items: this.state.itemsCopy });
    }
  };

  // onFilterQty = async () => {
  //     await this.setState({isFilterQty: !this.state.isFilterQty});
  //     if (this.state.isFilterQty) {
  //         this.setState({
  //             items: this.state.items.filter(e => e.external_onhand_qty !== "false") ,
  //             offset: 0,
  //             offsetFixed: 0,
  //             countP: 1
  //         });
  //     } else {
  //         this.setState({items: this.state.itemsCopy});
  //     }
  // }

  onFilterQty = async (e) => {
    console.log(e.target.value);

    if (e.target.value === "isnotequal") {
      this.setState({
        items: this.state.itemsCopy.filter(
          (e) =>
            (!isNaN(e.external_onhand_qty) &&
              !isNaN(parseFloat(e.external_onhand_qty)) &&
              parseFloat(e.external_onhand_qty)) != 0,
        ),
        offset: 0,
        offsetFixed: 0,
        countP: 1,
      });
    } else if (e.target.value === "isequal") {
      this.setState({
        items: this.state.itemsCopy.filter(
          (e) =>
            e.external_onhand_qty === "false" ||
            (!isNaN(e.external_onhand_qty) &&
              !isNaN(parseFloat(e.external_onhand_qty)) &&
              parseFloat(e.external_onhand_qty)) <= 0,
        ),
        offset: 0,
        offsetFixed: 0,
        countP: 1,
      });
    } else if (e.target.value === "") {
      await this.setState({ items: this.state.itemsCopy });
    }
    await this.setState({
      ofproducts: Math.round(this.state.items.length / 8),
    });
  };

  onPreviousProduct = async () => {
    await this.setState({
      offset: this.state.offset - 8,
      offsetFixed: this.state.offsetFixed - 1,
      countP: this.state.countP - 1,
    });
    if (this.state.offset < 0) {
      this.setState({ offset: 0, offsetFixed: 0, countP: 1 });
    } else {
      window.scrollTo(0, 0);
    }
  };

  onholdpage = () => {
    this.setState({ imageLoaded: true });
    console.log("load successfyully");
  };

  onNextProduct = async () => {
    await this.setState({
      offset: this.state.offset + 8,
      offsetFixed: this.state.offsetFixed + 1,
      countP: this.state.countP + 1,
      imageLoaded: false,
    });
    if (
      this.state.items.slice(this.state.offset, this.state.offset + 8)
        .length === 0
    ) {
      this.setState({
        offset: this.state.offset - 8,
        offsetFixed: this.state.offsetFixed - 1,
        countP: this.state.countP - 1,
      });
    } else {
      window.scrollTo(0, 0);
    }

    const interval = setInterval(async () => {
      await this.onholdpage();
    }, 1000);
    this.setState({ intervalp: interval });
  };

  onPrint = async () => {
    await localStorage.setItem("SOL", JSON.stringify(this.state.SOL));
    this.props.history.push("/Print");
  };

  onSelectFamily = async (e) => {
    await this.setState({
      selectFamily: e.target.value,
      selectBrand: "",
      selectGroup: "",
      selectCateg: "",
    });

    var values = await FilterFunction(
      this.state.selectFamily,
      this.state.items,
      this.state.itemsCopy,
      this.state.noData,
    );
    await this.setState({ items: values.items, noData: values.noData });

    var values = await FilterFunction(
      this.state.selectGroup,
      this.state.items,
      this.state.items,
      this.state.noData,
    );
    await this.setState({ items: values.items, noData: values.noData });

    var values = await FilterFunction(
      this.state.selectBrand,
      this.state.items,
      this.state.items,
      this.state.noData,
    );
    await this.setState({ items: values.items, noData: values.noData });

    var values = await FilterFunction(
      this.state.selectCateg,
      this.state.items,
      this.state.items,
      this.state.noData,
    );
    await this.setState({ items: values.items, noData: values.noData });

    await this.setState({
      ofproducts: Math.round(this.state.items.length / 8),
    });
    if (this.state.items.length <= 8) {
      this.setState({ ofproducts: 1 });
    } else {
      this.setState({ ofproducts: Math.round(this.state.items.length / 8) });
    }
    this.setState({
      productBrand: this.selectDistinct(this.state.items, "brand_id"),
      productCateg: this.selectDistinct(this.state.items, "product_categ_id"),
      productGroup: this.selectDistinct(this.state.items, "product_group_id"),
    });
  };

  onSelectGroup = async (e) => {
    this.setState({ selectGroup: e.target.value });

    var values = await FilterFunction(
      this.state.selectFamily,
      this.state.items,
      this.state.itemsCopy,
      this.state.noData,
    );
    await this.setState({ items: values.items, noData: values.noData });

    var values = await FilterFunction(
      this.state.selectGroup,
      this.state.items,
      this.state.items,
      this.state.noData,
    );
    await this.setState({ items: values.items, noData: values.noData });

    var values = await FilterFunction(
      this.state.selectBrand,
      this.state.items,
      this.state.items,
      this.state.noData,
    );
    await this.setState({ items: values.items, noData: values.noData });

    var values = await FilterFunction(
      this.state.selectCateg,
      this.state.items,
      this.state.items,
      this.state.noData,
    );
    await this.setState({ items: values.items, noData: values.noData });

    await this.setState({
      ofproducts: Math.round(this.state.items.length / 8),
    });
    if (this.state.items.length <= 8) {
      this.setState({ ofproducts: 1 });
    } else {
      this.setState({ ofproducts: Math.round(this.state.items.length / 8) });
    }
  };

  onSelectBrand = async (e) => {
    this.setState({
      selectBrand: e.target.value,
      selectGroup: "",
      selectCateg: "",
    });

    var values = await FilterFunction(
      this.state.selectFamily,
      this.state.items,
      this.state.itemsCopy,
      this.state.noData,
    );
    await this.setState({ items: values.items, noData: values.noData });

    var values = await FilterFunction(
      this.state.selectGroup,
      this.state.items,
      this.state.items,
      this.state.noData,
    );
    await this.setState({ items: values.items, noData: values.noData });

    var values = await FilterFunction(
      this.state.selectBrand,
      this.state.items,
      this.state.items,
      this.state.noData,
    );
    await this.setState({ items: values.items, noData: values.noData });

    var values = await FilterFunction(
      this.state.selectCateg,
      this.state.items,
      this.state.items,
      this.state.noData,
    );
    await this.setState({ items: values.items, noData: values.noData });

    await this.setState({
      ofproducts: Math.round(this.state.items.length / 8),
    });
    if (this.state.items.length <= 8) {
      this.setState({ ofproducts: 1 });
    } else {
      this.setState({ ofproducts: Math.round(this.state.items.length / 8) });
    }
    this.setState({
      productCateg: this.selectDistinct(this.state.items, "product_categ_id"),
      productGroup: this.selectDistinct(this.state.items, "product_group_id"),
    });
  };

  onSelectCateg = async (e) => {
    this.setState({ selectCateg: e.target.value, selectGroup: "" });

    var values = await FilterFunction(
      this.state.selectFamily,
      this.state.items,
      this.state.itemsCopy,
      this.state.noData,
    );
    await this.setState({ items: values.items, noData: values.noData });

    var values = await FilterFunction(
      this.state.selectGroup,
      this.state.items,
      this.state.items,
      this.state.noData,
    );
    await this.setState({ items: values.items, noData: values.noData });

    var values = await FilterFunction(
      this.state.selectBrand,
      this.state.items,
      this.state.items,
      this.state.noData,
    );
    await this.setState({ items: values.items, noData: values.noData });

    var values = await FilterFunction(
      this.state.selectCateg,
      this.state.items,
      this.state.items,
      this.state.noData,
    );
    await this.setState({ items: values.items, noData: values.noData });

    await this.setState({
      ofproducts: Math.round(this.state.items.length / 8),
    });
    if (this.state.items.length <= 8) {
      this.setState({ ofproducts: 1 });
    } else {
      this.setState({ ofproducts: Math.round(this.state.items.length / 8) });
    }
    this.setState({
      productGroup: this.selectDistinct(this.state.items, "product_group_id"),
    });
  };

  selectDistinct = (array, fieldName) => {
    const distinctObjects = [];
    const distinctValues = new Map();

    for (const obj of array) {
      const fieldValue = obj[fieldName];
      if (!distinctValues.has(fieldValue[1])) {
        distinctValues.set(fieldValue[1], fieldValue[0]);
        const distinctObj = {
          id: fieldValue[0],
          name: fieldValue[1],
        };
        distinctObjects.push(distinctObj);
      }
    }

    return distinctObjects;
  };

  cacheImage = async (imageUrl) => {
    const cache = await caches.open("image-cache");
    await cache.add(imageUrl);
  };
  getCachedImage = async (imageUrl) => {
    const cache = await caches.open("image-cache");
    const cachedResponse = await cache.match(imageUrl);
    if (cachedResponse) {
      return URL.createObjectURL(await cachedResponse.blob());
    }
    return imageUrl; // Fallback to network if not cached
  };

  sortItems = () => {
    return this.state.items.sort((a, b) =>
      a.product_tmpl_id[1].localeCompare(b.product_tmpl_id[1], ["en", "ar"], {
        sensitivity: "base",
        ignorePunctuation: true,
      }),
    );
  };

  oncatalog = async (id) => {
    await this.state.catalogs.map(async (catalog, index) => {
      if (index + 1 < this.state.catalogs.length) {
        if (catalog.id === this.state.catalogId) {
          var nextCategItems = [];
          await this.state.allitems.forEach((item) => {
            if (id !== 1) {
              if (item.categ_id[0] === id) {
                nextCategItems.push(item);
              }
              this.setState({
                items: nextCategItems,
                itemsCopy: nextCategItems,
              });
            } else {
              this.setState({
                items: this.state.allitems,
                itemsCopy: this.state.allitems,
              });
            }
          });
        }
        if (this.state.items.length === 0) {
          this.setState({ ofproducts: 1 });
        } else {
          this.setState({
            ofproducts: Math.round(this.state.items.length / 8),
          });
        }
      }
    });
    this.setState({ showAlertCatalog: false });
  };

  render() {
    console.log(this.state.fixed);

    if (this.state.loading) {
      return (
        <div
          className="container-fluid vh-100"
          style={stylesASAP.mainContainer}
        >
          {!this.state.alertUndefined ? null : (
            <div className="col alert alert-danger">
              <div className="row">
                <h6 className="col-sm-8">There seems to be a problem.</h6>
                <div className="col d-flex flex-row-reverse">
                  <div
                    className="btn"
                    style={stylesMed.wideButton}
                    onClick={() => window.location.reload()}
                  >
                    Reload
                  </div>
                </div>
              </div>
            </div>
          )}
          {this.state.count === 0 ? (
            <div className="alert alert-secondary">
              You have 0 Transactions to Sync with Odoo.
            </div>
          ) : (
            <div className="alert alert-danger">
              You have transactions to Sync with Odoo.
              <h5>Only sync when connected to the Internet!</h5>
            </div>
          )}
          <div className="pt-3 row">
            <div className="col">
              <div className="punsh btn" onClick={() => this.onCancel()}>
                Cancel
              </div>
            </div>
            <div className="col text-center">
              <h3>{this.state.selectedClientName}</h3>
            </div>
            <div className="col d-flex flex-row-reverse">
              <div className={"punsh btn disabled"} onClick={this.onSave}>
                Save
              </div>
            </div>
          </div>
          <div className="pt-3">
            {this.state.currentType === 4 ? (
              <input
                type="text"
                className="form-control"
                placeholder="Scan Here"
                value={this.state.barcode}
                onKeyDown={(e) => {
                  if (e.keyCode === 13) {
                    this.searchItem();
                  }
                }}
                onChange={(text) => this.onSearchDelivery(text)}
              />
            ) : (
              <input
                type="text"
                className="form-control responsive-input"
                placeholder="Search Here"
                value={this.state.barcode}
                onChange={(text) => this.onSearch(text)}
              />
            )}
          </div>
          <div className="pt-3 text-center">
            <div className="spinner-border" style={stylesASAP.spinner}></div>
          </div>

          <Modal show={this.state.showPrint} animation={false}>
            <Modal.Body>
              <Print history={this.props.history}></Print>
            </Modal.Body>
          </Modal>
        </div>
      );
    } else {
      return (
        <div
          className="container-fluid vh-100 "
          style={stylesASAP.mainBackgroundColor}
        >
          {this.state.count === 0 ? (
            <div className="alert alert-secondary">
              You have 0 Sales Orders to Sync with Odoo.
            </div>
          ) : (
            <div className="alert alert-danger">
              You have{" "}
              {this.state.count +
                " " +
                this.state.transactionTypes[this.state.currentType].name}{" "}
              to Sync with Odoo.
              <h5>Only sync when connected to the Internet!</h5>
            </div>
          )}
          <div className="pt-3 row text-center mt-3">
            <div className="">
              <FcBusinessman size={40} />
            </div>
            <div className=" mt-1 text-center">
              <h3 className="big">
                {" "}
                {this.state.selectedClientName}{" "}
                <span style={{ color: "red", fontSize: "25px" }}>
                  - New
                  {this.state.currentType !== -1
                    ? this.state.transactionTypes[this.state.currentType].name
                    : null}{" "}
                </span>
              </h3>
            </div>
            <hr />
          </div>
          <div className=" row">
            <div className="col-6 d-flex flex-row-reverse">
              <div className="col">
                {this.state.catalogs.map((item, index) => {
                  if (item.id === this.state.catalogId) {
                    return (
                      <div className=" little pt-3 text-center h3 " key={index}>
                        {item.name} Items
                      </div>
                    );
                  } else return null;
                })}
              </div>

              {/* <FcSynchronize size={60} onClick={this.showAlertImages} /> */}
              <div className=" cancel btn" onClick={() => this.onCancel()}>
                Cancel
              </div>
            </div>

            <div className="pt-3 col-6 d-flex flex-row-reverse">
              <div className="punsh1 btn" onClick={this.showAlertChange}>
                Save
              </div>
              <div className="punsh1 btn" onClick={this.showAlertPreview}>
                Preview
              </div>
              {this.state.lastSo !== null && this.state.lastSo.length !== 0 ? (
                this.state.lastSo[0].ClientId === this.state.selectedClient &&
                this.state.lastSo[0].type ===
                  this.state.transactionTypes[this.state.currentType].LS ? (
                  <div className="punsh1 btn" onClick={this.loadData}>
                    Load
                  </div>
                ) : null
              ) : null}
              <div className="punsh1 btn" onClick={this.showAlertRemark}>
                Remark
              </div>
            </div>
          </div>

          <div className="row mt-3">
            <div className="col-4 pt-3">
              <h5 className="place card-text">
                <FcSearch size={25} />
                Search{" "}
              </h5>

              {this.state.currentType === 4 ? (
                <input
                  type="text"
                  className="form-control mb-3"
                  placeholder="Scan Here"
                  value={this.state.barcode}
                  onKeyDown={(e) => {
                    if (e.keyCode === 13) {
                      this.searchItem();
                    }
                  }}
                  onChange={(text) => this.onSearchDelivery(text)}
                />
              ) : (
                // <input
                //   type="text"
                //   className="form-control"
                //   placeholder="Search Heree"
                //   onChange={(text) => this.onSearch(text)}
                // />
                <div style={{ position: "relative", width: "200px" }}>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search Here"
                    value={this.state.searchText}
                    onChange={(e) => this.onSearch(e.target.value)}
                    // onChange={(text) => this.onSearch(text)}
                  />
                  {this.state.searchText !== "" ? (
                    <span
                      onClick={this.clearSearch}
                      style={{
                        position: "absolute",
                        right: "10px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        cursor: "pointer",
                        fontWeight: "bold",
                        color: "#ff0000ff",
                      }}
                    >
                      X
                    </span>
                  ) : null}
                </div>
              )}
            </div>
            <div className="col-4 pt-3">
              <h5 className="place card-text">
                {" "}
                <FcFilledFilter size={25} />
                Stock Filter
              </h5>
              <div
                className="custom-select"
                style={{ position: "relative", width: "150px" }}
              >
                <select
                  className="select-style form-control"
                  onChange={this.onFilterQty}
                >
                  <option value=""></option>
                  <option value="isequal">is equal zero </option>
                  <option value="isnotequal">is not equal zero </option>
                </select>
                <div className="select-arrow"></div>
              </div>
            </div>

            {/* <div className="col-2 punsh1 btn  mt-5" onClick={this.showAlertCatalog}>
             Categories
              </div> */}

            <div className="col-4 d-flex flex-row-reverse ">
              <div className="row mt-5">
                {/* <AiOutlineFilter className="col btn"
                                                     style={(this.state.isFilterQty) ? stylesASAP.isgridClicked : stylesASAP.isgrid}
                                                     onClick={this.onFilterQty}/> */}

                <GrCatalog
                  className="col btn"
                  style={stylesASAP.isgrid}
                  onClick={this.showAlertCatalog}
                />

                <SlBasket
                  className="col btn"
                  style={
                    this.state.isFilter
                      ? stylesASAP.isgridClicked
                      : stylesASAP.isgrid
                  }
                  onClick={this.onFilter}
                />
                <AiOutlineUnorderedList
                  className="col btn"
                  style={
                    !this.state.isGrid
                      ? stylesASAP.isgridClicked
                      : stylesASAP.isgrid
                  }
                  onClick={this.onList}
                />
                <BsFillGrid3X3GapFill
                  className="col btn"
                  style={
                    this.state.isGrid
                      ? stylesASAP.isgridClicked
                      : stylesASAP.isgrid
                  }
                  onClick={this.onGrid}
                />
              </div>
            </div>
          </div>
          {/* <div className="row pt-3">
              <h5 className="place card-text">Global %</h5>
              <input
                className="form-control"
                placeholder="nsncjn"
                type="number"
                value={Number(this.state.globalDiscount)}
                onChange={this.onChangeGlobalDiscount}
                onKeyDown={(e) =>
                  this.state.preventSymbols.includes(e.key) &&
                  e.preventDefault()
                }
                min="0"
              />
            </div> */}

          {this.state.currentType !== 4 ? (
            <div style={stylesASAP.mainBackgroundColor}>
              <div className="mb-2 ">
                <div className="row mt-2  Box-Shadow-receipt">
                  <div className="row">
                    <div className="col">
                      <p className="little pt-3 text-center h4">
                        Sub-Total:{" "}
                        {this.numberWithCommas(
                          this.state.totalOrderPriceUntaxed.toFixed(
                            this.state.fixed,
                          ),
                        )}
                      </p>
                    </div>
                    {this.state.settingArray.map((item) => {
                      if (item.key === "EnableItemWeightDisplay") {
                        return item.value === "1" ? (
                          <div className="col">
                            <p className="little pt-3 text-center h4">
                              {this.state.totalWeight !== 0
                                ? "Total-Weight" +
                                  " " +
                                  this.state.totalWeight +
                                  " " +
                                  "kg"
                                : null}
                            </p>
                          </div>
                        ) : null;
                      }
                    })}
                    {/* <div className="col">
                      <p className="little pt-3 text-center h4">
                        {this.state.totalWeight !== 0
                          ? "Total-Weight" +
                            " " +
                            this.state.totalWeight +
                            " " +
                            "kg"
                          : null}
                      </p>
                    </div> */}
                    <div className="col">
                      <p className="pt-3 text-center h4 ">
                        VAT:{" "}
                        {this.state.totalVAT !== null
                          ? this.numberWithCommas(
                              this.state.totalVAT.toFixed(this.state.fixed),
                            )
                          : 0}
                      </p>
                    </div>
                    <div className="col">
                      <p className="little pt-3 text-center h4">
                        Total:{" "}
                        {/* {this.state.totalOrderPriceTaxed !== null
                          ? this.numberWithCommas(
                              this.state.totalOrderPriceTaxed.toFixed(
                                this.state.fixed,
                              ),
                            )
                          : 0} */}
                        {this.state.totalOrderPriceTaxed !== null
                          ? Number(
                              this.state.totalOrderPriceTaxed,
                            ).toLocaleString(undefined, {
                              minimumFractionDigits:
                                Number(this.state.fixed) || 2,
                              maximumFractionDigits:
                                Number(this.state.fixed) || 2,
                            })
                          : 0}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : null}

          <div>
            {!this.state.isGrid ? (
              this.state.items.length === 0 && this.state.currentType === 4 ? (
                <div>
                  <h3 className="card-text" style={stylesASAP.itemTitle}>
                    Start Scanning Items
                  </h3>
                </div>
              ) : this.state.items.length === 0 ? (
                <div>
                  <h3 className="card-text text-center text-danger">
                    No items found in this category
                  </h3>
                </div>
              ) : (
                this.state.items
                  .slice(this.state.offset, this.state.offset + 8)
                  .map((item, index, arr) => {
                    if (this.state.currentType !== 4) {
                      return (
                        <div
                          className="row mt-2"
                          style={stylesASAP.cardsecondhalf}
                        >
                          {this.state.settingArray.map((url) => {
                            if (url.key === "Product_Images_Base_URL") {
                              return (
                                <div className="col-2 mt-2">
                                  {this.state.imageLoaded ? (
                                    <img
                                      className="image1"
                                      src={
                                        url.value +
                                        item.default_code +
                                        ".png?lastmod=" +
                                        this.state.random
                                      }
                                      alt="not found"
                                      onClick={() =>
                                        this.showAlertimage(
                                          item.default_code,
                                          item.description,
                                        )
                                      }
                                      onLoad={() => {
                                        this.handleImageLoad(item.default_code);
                                      }}
                                    />
                                  ) : (
                                    <div
                                      className="spinner-border"
                                      role="status"
                                    >
                                      <span className="visually-hidden">
                                        Loading...
                                      </span>
                                    </div>
                                  )}
                                </div>
                              );
                            }
                          })}
                          {/* <div className="col-2 mt-2">
                            {this.state.imageLoaded ? (
                              <img
                                className="image1"
                                src={
                                  "https://ghazzawibros.net/images/thumbs/demo_items/" +
                                  item.default_code +
                                  ".png"
                                }
                                alt="not found"
                                onClick={() =>
                                  this.showAlertimage(
                                    item.default_code,
                                    item.description
                                  )
                                }
                                onLoad={() =>
                                  this.handleImageLoad(item.default_code)
                                }
                              />
                            ) : (
                              <div className="spinner-border" role="status">
                                <span className="visually-hidden">
                                  Loading...
                                </span>
                              </div>
                            )}
                          </div> */}
                          <div className="col-10 mt-1">
                            <div className="row">
                              <h4 className="textcode col-6   text-center">
                                {item.name}
                              </h4>
                              <h5 className="little col-4 card-text  text-center">
                                {item.default_code}
                              </h5>
                            </div>

                            <div className="row  mt-1">
                              <div className="col-3">
                                <p
                                  className="little"
                                  style={stylesASAP.itemTitle}
                                >
                                  Qty Piece:
                                </p>
                                <div className="input-group">
                                  <div className="input-group-prepend">
                                    <button
                                      className="littleB"
                                      type="button"
                                      onClick={() =>
                                        this.incrementQty(
                                          item.id,
                                          item,
                                          1,
                                          0,
                                          item.uom_id[1],
                                          item.misctext2,
                                        )
                                      }
                                    >
                                      +
                                    </button>
                                  </div>
                                  <input
                                    className="littleinput"
                                    type="number"
                                    value={
                                      this.state.SOL[item.id] !== undefined &&
                                      this.state.SOL[item.id] !== null &&
                                      this.state.SOL[item.id].packages !==
                                        undefined &&
                                      this.state.SOL[item.id].packages !== null
                                        ? this.state.SOL[item.id].packages[0]
                                            .qty
                                        : this.state.SOL[item.id] !==
                                              undefined &&
                                            this.state.SOL[item.id] !== null
                                          ? this.state.SOL[item.id].qty
                                          : ""
                                    }
                                    onKeyDown={(e) =>
                                      this.state.preventSymbols.includes(
                                        e.key,
                                      ) && e.preventDefault()
                                    }
                                    min="0"
                                    onChange={this.onChangeQty(
                                      item.id,
                                      item.fixed_price,
                                      item.taxes_id,
                                      item,
                                      item.weight,
                                      1,
                                      0,
                                      item.misctext2,
                                    )}
                                  />
                                  <div className="input-group-prepend">
                                    <button
                                      className="littleB"
                                      type="button"
                                      onClick={() =>
                                        this.dicrementQty(item.id, item, 1, 0)
                                      }
                                    >
                                      -
                                    </button>
                                  </div>
                                </div>
                              </div>
                              {/* <div className="col-4">
                                <p
                                  className="little"
                                  style={stylesASAP.itemTitle}
                                >
                                  Free Piece:
                                </p>
                                <div className="input-group">
                                  <div className="input-group-prepend">
                                    <button
                                      className="littleB text-center "
                                      onClick={() =>
                                        this.incrementfree(item.id, item)
                                      }
                                    >
                                      +
                                    </button>
                                  </div>
                                  <input
                                    className={
                                      this.state.SOL[index] === undefined ||
                                      this.state.SOL[index] === null ||
                                      this.state.SOL[index].qty === undefined
                                        ? "littleinput disabled"
                                        : "littleinput"
                                    }
                                    type="number"
                                    value={
                                      this.state.SOL[item.id] !== undefined &&
                                      this.state.SOL[item.id] !== null &&
                                      this.state.SOL[item.id].freeItem !==
                                        undefined
                                        ? this.state.SOL[item.id].freeItem
                                        : ""
                                    }
                                    onKeyDown={(e) =>
                                      this.state.preventSymbols.includes(
                                        e.key
                                      ) && e.preventDefault()
                                    }
                                    min="0"
                                    onChange={this.onChangeFreeItems(
                                      item.id,
                                      item.fixed_price,
                                      item,
                                      item.weight
                                    )}
                                  />
                                  <div className="input-group-prepend">
                                    <button
                                      className="littleB"
                                      type="button"
                                      onClick={() =>
                                        this.dicrementfree(item.id, item)
                                      }
                                    >
                                      -
                                    </button>
                                  </div>
                                </div>
                              </div> */}

                              {/* {this.state.settingArray.map((sett) => {
                                if (sett.key === "DisableFreeItemUI") {
                                  if (sett.value === "true") {
                                    return (
                                      <div className="col-4">
                                        <p
                                          className="little"
                                          style={stylesASAP.itemTitle}
                                        >
                                          Free Piece:
                                        </p>
                                        <div className="input-group ">
                                          <div className="input-group-prepend ">
                                            <button
                                              className="littleB text-center "
                                              onClick={() =>
                                                this.incrementfree(
                                                  item.id,
                                                  item
                                                )
                                              }
                                              disabled={true}
                                            >
                                              +
                                            </button>
                                          </div>

                                          <input
                                            className="littleinput "
                                            type="number"
                                             disabled={true}
                                            value={
                                              this.state.SOL[item.id] &&
                                              this.state.SOL[item.id]
                                                .freeItem !== undefined
                                                ? this.state.SOL[item.id]
                                                    .freeItem
                                                : ""
                                            }
                                            onKeyDown={(e) =>
                                              this.state.preventSymbols.includes(
                                                e.key
                                              ) && e.preventDefault()
                                            }
                                            min="0"
                                            onChange={this.onChangeFreeItems(
                                              item.id,
                                              item.fixed_price,
                                              item,
                                              item.weight
                                            )}
                                          />

                                          <div className="input-group-prepend ">
                                            <button
                                              className="littleB disabled"
                                              type="button"
                                               disabled={true}
                                              onClick={() =>
                                                this.dicrementfree(
                                                  item.id,
                                                  item
                                                )
                                              }
                                            >
                                              -
                                            </button>
                                          </div>
                                        </div>
                                      </div>
                                    );
                                  } else {
                                     {this.state.settingArray.map((set) => {
                                    if (
                                      set.key === "DisableFreeItemPromotion"
                                    ) {
                                      if (
                                        set.value === "true" &&
                                        item.misctext1 !== false &&
                                        item.misctext1 !== undefined &&
                                        item.misctext1 !== null
                                      ) {
                                        return (
                                          <div className="col-4">
                                            <p
                                              className="little"
                                              style={stylesASAP.itemTitle}
                                            >
                                              Free Piece:
                                            </p>
                                            <div className="input-group ">
                                              <div className="input-group-prepend ">
                                                <button
                                                  className="littleB text-center "
                                                   disabled={true}
                                                  onClick={() =>
                                                    this.incrementfree(
                                                      item.id,
                                                      item
                                                    )
                                                  }
                                                >
                                                  +
                                                </button>
                                              </div>

                                              <input
                                                className="littleinput "
                                                type="number"
                                                 disabled={true}
                                                value={
                                                  this.state.SOL[item.id] &&
                                                  this.state.SOL[item.id]
                                                    .freeItem !== undefined
                                                    ? this.state.SOL[item.id]
                                                        .freeItem
                                                    : ""
                                                }
                                                onKeyDown={(e) =>
                                                  this.state.preventSymbols.includes(
                                                    e.key
                                                  ) && e.preventDefault()
                                                }
                                                min="0"
                                                onChange={this.onChangeFreeItems(
                                                  item.id,
                                                  item.fixed_price,
                                                  item,
                                                  item.weight
                                                )}
                                              />

                                              <div className="input-group-prepend ">
                                                <button
                                                  className="littleB "
                                                  type="button"
                                                   disabled={true}
                                                  onClick={() =>
                                                    this.dicrementfree(
                                                      item.id,
                                                      item
                                                    )
                                                  }
                                                >
                                                  -
                                                </button>
                                              </div>
                                            </div>
                                          </div>
                                        );
                                      } else {
                                        <div className="col-4">
                                          <p
                                            className="little"
                                            style={stylesASAP.itemTitle}
                                          >
                                            Free Piece:
                                          </p>
                                          <div className="input-group">
                                            <div className="input-group-prepend">
                                              <button
                                                className="littleB text-center "
                                                onClick={() =>
                                                  this.incrementfree(
                                                    item.id,
                                                    item
                                                  )
                                                }
                                              >
                                                +
                                              </button>
                                            </div>
                                            <input
                                              className={
                                                this.state.SOL[index] ===
                                                  undefined ||
                                                this.state.SOL[index] ===
                                                  null ||
                                                this.state.SOL[index].qty ===
                                                  undefined
                                                  ? "littleinput disabled"
                                                  : "littleinput"
                                              }
                                              type="number"
                                              value={
                                                this.state.SOL[item.id] !==
                                                  undefined &&
                                                this.state.SOL[item.id] !==
                                                  null &&
                                                this.state.SOL[item.id]
                                                  .freeItem !== undefined
                                                  ? this.state.SOL[item.id]
                                                      .freeItem
                                                  : ""
                                              }
                                              onKeyDown={(e) =>
                                                this.state.preventSymbols.includes(
                                                  e.key
                                                ) && e.preventDefault()
                                              }
                                              min="0"
                                              onChange={this.onChangeFreeItems(
                                                item.id,
                                                item.fixed_price,
                                                item,
                                                item.weight
                                              )}
                                            />
                                            <div className="input-group-prepend">
                                              <button
                                                className="littleB"
                                                type="button"
                                                onClick={() =>
                                                  this.dicrementfree(
                                                    item.id,
                                                    item
                                                  )
                                                }
                                              >
                                                -
                                              </button>
                                            </div>
                                          </div>
                                        </div>;
                                      }
                                    }})}
                                  }
                                } else {
                                  <div className="col-4">
                                    <p
                                      className="little"
                                      style={stylesASAP.itemTitle}
                                    >
                                      Free Piece:
                                    </p>
                                    <div className="input-group">
                                      <div className="input-group-prepend">
                                        <button
                                          className="littleB text-center "
                                          onClick={() =>
                                            this.incrementfree(item.id, item)
                                          }
                                        >
                                          +
                                        </button>
                                      </div>
                                      <input
                                        className={
                                          this.state.SOL[index] === undefined ||
                                          this.state.SOL[index] === null ||
                                          this.state.SOL[index].qty ===
                                            undefined
                                            ? "littleinput disabled"
                                            : "littleinput"
                                        }
                                        type="number"
                                        value={
                                          this.state.SOL[item.id] !==
                                            undefined &&
                                          this.state.SOL[item.id] !== null &&
                                          this.state.SOL[item.id].freeItem !==
                                            undefined
                                            ? this.state.SOL[item.id].freeItem
                                            : ""
                                        }
                                        onKeyDown={(e) =>
                                          this.state.preventSymbols.includes(
                                            e.key
                                          ) && e.preventDefault()
                                        }
                                        min="0"
                                        onChange={this.onChangeFreeItems(
                                          item.id,
                                          item.fixed_price,
                                          item,
                                          item.weight
                                        )}
                                      />
                                      <div className="input-group-prepend">
                                        <button
                                          className="littleB"
                                          type="button"
                                          onClick={() =>
                                            this.dicrementfree(item.id, item)
                                          }
                                        >
                                          -
                                        </button>
                                      </div>
                                    </div>
                                  </div>;
                                }
                                  
                              })} */}

                              {(() => {
                                // Determine settings once
                                const disableUI = this.state.settingArray.find(
                                  (s) =>
                                    s.key === "DisableFreeItemUI" &&
                                    s.value === "true",
                                );

                                const disablePromotion =
                                  this.state.settingArray.find(
                                    (s) =>
                                      s.key === "DisableFreeItemPromotion" &&
                                      s.value === "true",
                                  ) && item.misctext1;

                                // Case 1 has priority over case 2
                                const isDisabled = disableUI
                                  ? true
                                  : disablePromotion
                                    ? true
                                    : false;

                                return (
                                  <div className="col-3">
                                    <p
                                      className="little"
                                      style={stylesASAP.itemTitle}
                                    >
                                      Free Piece:
                                    </p>
                                    <div className="input-group">
                                      <div className="input-group-prepend">
                                        <button
                                          className="littleB text-center"
                                          onClick={() =>
                                            this.incrementfree(item.id, item)
                                          }
                                          disabled={isDisabled}
                                        >
                                          +
                                        </button>
                                      </div>
                                      <input
                                        className={
                                          !this.state.SOL[item.id]
                                            ? "littleinput disabled"
                                            : "littleinput"
                                        }
                                        type="number"
                                        disabled={isDisabled}
                                        value={
                                          this.state.SOL[item.id]?.freeItem ??
                                          ""
                                        }
                                        onKeyDown={(e) =>
                                          this.state.preventSymbols.includes(
                                            e.key,
                                          ) && e.preventDefault()
                                        }
                                        min="0"
                                        onChange={this.onChangeFreeItems(
                                          item.id,
                                          item.fixed_price,
                                          item,
                                          item.weight,
                                        )}
                                      />
                                      <div className="input-group-prepend">
                                        <button
                                          className="littleB"
                                          type="button"
                                          onClick={() =>
                                            this.dicrementfree(item.id, item)
                                          }
                                          disabled={isDisabled}
                                        >
                                          -
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                );
                              })()}
                              {/* {(!this.state.settingArray.find(
                                (s) => s.key === "HideManualDiscount",
                              ) ||
                                this.state.settingArray.find(
                                  (s) => s.key === "HideManualDiscount",
                                )?.value === "0") && (
                                <div className="col-3">
                                  <p
                                    className="little"
                                    style={stylesASAP.itemTitle}
                                  >
                                    Disc by %:
                                  </p>

                                  <div className="input-group">
                                    <div className="input-group-prepend">
                                      <button
                                        className="littleB"
                                        type="button"
                                        disabled={
                                          !this.state.SOL[item.id] ||
                                          !this.state.SOL[item.id].qty ||
                                          this.state.SOL[item.id].qty === 0
                                        }
                                        onClick={() =>
                                          this.incrementDisc(item.id, item)
                                        }
                                      >
                                        +
                                      </button>
                                    </div>

                                    <input
                                      className="littleinput"
                                      type="number"
                                      disabled={
                                        !this.state.SOL[item.id] ||
                                        !this.state.SOL[item.id].qty ||
                                        this.state.SOL[item.id].qty === 0
                                      }
                                      value={
                                        this.state.SOL[item.id]?.disc ?? ""
                                      }
                                      onKeyDown={(e) =>
                                        this.state.preventSymbols.includes(
                                          e.key,
                                        ) && e.preventDefault()
                                      }
                                      min="0"
                                      onChange={this.onChangeDisc(
                                        item.id,
                                        item.taxes_id,
                                        item.productId,
                                        item.fixed_price,
                                      )}
                                    />

                                    <div className="input-group-prepend">
                                      <button
                                        className="littleB"
                                        type="button"
                                        disabled={
                                          !this.state.SOL[item.id] ||
                                          !this.state.SOL[item.id].qty ||
                                          this.state.SOL[item.id].qty === 0
                                        }
                                        onClick={() =>
                                          this.dicrementDisc(item.id, item)
                                        }
                                      >
                                        -
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              )} */}
                              {(!this.state.settingArray.find(
                                (s) => s.key === "HideManualDiscount",
                              ) ||
                                this.state.settingArray.find(
                                  (s) => s.key === "HideManualDiscount",
                                )?.value === "0") &&
                                (() => {
                                  const disableManualDiscount =
                                    this.state.settingArray.find(
                                      (s) => s.key === "DisableManualDiscount",
                                    )?.value === "1";

                                  return (
                                    <div className="col-3">
                                      <p
                                        className="little"
                                        style={stylesASAP.itemTitle}
                                      >
                                        Disc by %:
                                      </p>

                                      <div className="input-group">
                                        <div className="input-group-prepend">
                                          <button
                                            className="littleB"
                                            type="button"
                                            disabled={
                                              disableManualDiscount ||
                                              !this.state.SOL[item.id] ||
                                              !this.state.SOL[item.id].qty ||
                                              this.state.SOL[item.id].qty === 0
                                            }
                                            onClick={() =>
                                              this.incrementDisc(item.id, item)
                                            }
                                          >
                                            +
                                          </button>
                                        </div>

                                        <input
                                          className="littleinput"
                                          type="number"
                                          disabled={
                                            disableManualDiscount ||
                                            !this.state.SOL[item.id] ||
                                            !this.state.SOL[item.id].qty ||
                                            this.state.SOL[item.id].qty === 0
                                          }
                                          value={
                                            this.state.SOL[item.id]?.disc ?? ""
                                          }
                                          onKeyDown={(e) =>
                                            this.state.preventSymbols.includes(
                                              e.key,
                                            ) && e.preventDefault()
                                          }
                                          min="0"
                                          onChange={this.onChangeDisc(
                                            item.id,
                                            item.taxes_id,
                                            item.productId,
                                            item.fixed_price,
                                            item,
                                          )}
                                        />

                                        <div className="input-group-prepend">
                                          <button
                                            className="littleB"
                                            type="button"
                                            disabled={
                                              disableManualDiscount ||
                                              !this.state.SOL[item.id] ||
                                              !this.state.SOL[item.id].qty ||
                                              this.state.SOL[item.id].qty === 0
                                            }
                                            onClick={() =>
                                              this.dicrementDisc(item.id, item)
                                            }
                                          >
                                            -
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                  );
                                })()}

                              {/* <div className="col-3">
                                <p
                                  className="little"
                                  style={stylesASAP.itemTitle}
                                >
                                  Disc by %:
                                </p>
                                <div className="input-group">
                                  {this.state.SOL[item.id] !== undefined &&
                                  this.state.SOL[item.id] !== null ? (
                                    <div className="input-group-prepend">
                                      <button
                                        className="littleB"
                                        type="button"
                                        disabled={
                                          this.state.SOL[item.id].qty ===
                                            undefined ||
                                          this.state.SOL[item.id].qty === "" ||
                                          this.state.SOL[item.id].qty === 0
                                            ? true
                                            : false
                                        }
                                        onClick={() =>
                                          this.incrementDisc(item.id, item)
                                        }
                                      >
                                        +
                                      </button>
                                    </div>
                                  ) : (
                                    <div className="input-group-prepend">
                                      <button
                                        className="littleB"
                                        type="button"
                                        disabled={true}
                                        onClick={() =>
                                          this.incrementDisc(item.id, item)
                                        }
                                      >
                                        +
                                      </button>
                                    </div>
                                  )}
                                  {this.state.SOL[item.id] !== undefined &&
                                  this.state.SOL[item.id] !== null ? (
                                    <input
                                      className="littleinput"
                                      type="number"
                                      disabled={
                                        this.state.SOL[item.id].qty ===
                                          undefined ||
                                        this.state.SOL[item.id].qty === "" ||
                                        this.state.SOL[item.id].qty === 0
                                          ? true
                                          : false
                                      }
                                      value={
                                        this.state.SOL[item.id] !== undefined &&
                                        this.state.SOL[item.id] !== null &&
                                        this.state.SOL[item.id].disc !==
                                          undefined &&
                                        this.state.SOL[item.id].disc !== null
                                          ? this.state.SOL[item.id].disc
                                          : ""
                                      }
                                      onKeyDown={(e) =>
                                        this.state.preventSymbols.includes(
                                          e.key
                                        ) && e.preventDefault()
                                      }
                                      min="0"
                                      onChange={this.onChangeDisc(
                                        item.id,
                                        item.taxes_id,
                                        item.productId,
                                        item.fixed_price
                                      )}
                                    />
                                  ) : (
                                    <input
                                      className="littleinput"
                                      type="number"
                                      disabled={true}
                                      value={
                                        this.state.SOL[item.id] !== undefined &&
                                        this.state.SOL[item.id] !== null &&
                                        this.state.SOL[item.id].disc !==
                                          undefined &&
                                        this.state.SOL[item.id].disc !== null
                                          ? this.state.SOL[item.id].disc
                                          : ""
                                      }
                                      onKeyDown={(e) =>
                                        this.state.preventSymbols.includes(
                                          e.key
                                        ) && e.preventDefault()
                                      }
                                      min="0"
                                      onChange={this.onChangeDisc(
                                        item.id,
                                        item.taxes_id,
                                        item.productId,
                                        item.fixed_price
                                      )}
                                    />
                                  )}
                                  {this.state.SOL[item.id] !== undefined &&
                                  this.state.SOL[item.id] !== null ? (
                                    <div className="input-group-prepend">
                                      <button
                                        className="littleB"
                                        type="button"
                                        disabled={
                                          this.state.SOL[item.id].qty ==
                                            undefined ||
                                          this.state.SOL[item.id].qty === "" ||
                                          this.state.SOL[item.id].qty === 0
                                            ? true
                                            : false
                                        }
                                        onClick={() =>
                                          this.dicrementDisc(item.id, item)
                                        }
                                      >
                                        -
                                      </button>
                                    </div>
                                  ) : (
                                    <div className="input-group-prepend">
                                      <button
                                        className="littleB"
                                        type="button"
                                        disabled={true}
                                        onClick={() =>
                                          this.dicrementDisc(item.id, item)
                                        }
                                      >
                                        -
                                      </button>
                                    </div>
                                  )}
                                </div>
                              </div> */}
                              {(!this.state.settingArray.find(
                                (s) => s.key === "HideManualDiscount",
                              ) ||
                                this.state.settingArray.find(
                                  (s) => s.key === "HideManualDiscount",
                                )?.value === "0") &&
                                (() => {
                                  const disableManualDiscount =
                                    this.state.settingArray.find(
                                      (s) => s.key === "DisableManualDiscount",
                                    )?.value === "1";

                                  return (
                                    <div className="col-3">
                                      <p
                                        className="little"
                                        style={stylesASAP.itemTitle}
                                      >
                                        Disc by Amount:
                                      </p>

                                      <div className="input-group">
                                        <div className="input-group-prepend">
                                          <button
                                            className="littleB"
                                            type="button"
                                            disabled={
                                              disableManualDiscount ||
                                              !this.state.SOL[item.id] ||
                                              !this.state.SOL[item.id].qty ||
                                              this.state.SOL[item.id].qty === 0
                                            }
                                            onClick={() =>
                                              this.incrementDiscAmount(
                                                item.id,
                                                item,
                                              )
                                            }
                                          >
                                            +
                                          </button>
                                        </div>

                                        <input
                                          className="littleinput"
                                          type="text"
                                          disabled={
                                            disableManualDiscount ||
                                            !this.state.SOL[item.id] ||
                                            !this.state.SOL[item.id].qty ||
                                            this.state.SOL[item.id].qty === 0
                                          }
                                          // value={
                                          //   this.state.SOL[item.id]
                                          //     ?.discAmount ?? ""
                                          // }
                                            value={
    this.state.SOL[item.id]?.discAmount?.toLocaleString() ?? ""
  }
                                          onKeyDown={(e) =>
                                            this.state.preventSymbols.includes(
                                              e.key,
                                            ) && e.preventDefault()
                                          }
                                          min="0"
                                          onChange={this.onChangeDiscAmount(
                                            item.id,
                                            item.taxes_id,
                                            item.productId,
                                            item.fixed_price,
                                            item,
                                          )}
                                        />

                                        <div className="input-group-prepend">
                                          <button
                                            className="littleB"
                                            type="button"
                                            disabled={
                                              disableManualDiscount ||
                                              !this.state.SOL[item.id] ||
                                              !this.state.SOL[item.id].qty ||
                                              this.state.SOL[item.id].qty === 0
                                            }
                                            onClick={() =>
                                              this.decrementDiscAmount(
                                                item.id,
                                                item,
                                              )
                                            }
                                          >
                                            -
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                  );
                                })()}

                              {/* <div className="col-3">
                                <p
                                  className="little"
                                  style={stylesASAP.itemTitle}
                                >
                                  Disc by Amount:
                                </p>
                                <div className="input-group">
                                  {this.state.SOL[item.id] !== undefined &&
                                  this.state.SOL[item.id] !== null ? (
                                    <div className="input-group-prepend">
                                      <button
                                        className="littleB"
                                        type="button"
                                        disabled={
                                          this.state.SOL[item.id].qty ===
                                            undefined ||
                                          this.state.SOL[item.id].qty === "" ||
                                          this.state.SOL[item.id].qty === 0
                                            ? true
                                            : false
                                        }
                                        onClick={() =>
                                          this.incrementDiscAmount(
                                            item.id,
                                            item,
                                          )
                                        }
                                      >
                                        +
                                      </button>
                                    </div>
                                  ) : (
                                    <div className="input-group-prepend">
                                      <button
                                        className="littleB"
                                        type="button"
                                        disabled={true}
                                        onClick={() =>
                                          this.incrementDiscAmount(
                                            item.id,
                                            item,
                                          )
                                        }
                                      >
                                        +
                                      </button>
                                    </div>
                                  )}
                                  {this.state.SOL[item.id] !== undefined &&
                                  this.state.SOL[item.id] !== null ? (
                                    <input
                                      className="littleinput"
                                      type="number"
                                      disabled={
                                        this.state.SOL[item.id].qty ===
                                          undefined ||
                                        this.state.SOL[item.id].qty === "" ||
                                        this.state.SOL[item.id].qty === 0
                                          ? true
                                          : false
                                      }
                                      value={
                                        this.state.SOL[item.id] !== undefined &&
                                        this.state.SOL[item.id] !== null &&
                                        this.state.SOL[item.id].discAmount !==
                                          undefined &&
                                        this.state.SOL[item.id].discAmount !==
                                          null
                                          ? this.state.SOL[item.id].discAmount
                                          : ""
                                      }
                                      onKeyDown={(e) =>
                                        this.state.preventSymbols.includes(
                                          e.key,
                                        ) && e.preventDefault()
                                      }
                                      min="0"
                                      onChange={this.onChangeDiscAmount(
                                        item.id,
                                        item.taxes_id,
                                        item.productId,
                                        item.fixed_price,
                                        item,
                                      )}
                                    />
                                  ) : (
                                    <input
                                      className="littleinput"
                                      type="number"
                                      disabled={true}
                                      value={
                                        this.state.SOL[item.id] !== undefined &&
                                        this.state.SOL[item.id] !== null &&
                                        this.state.SOL[item.id].disc !==
                                          undefined &&
                                        this.state.SOL[item.id].disc !== null
                                          ? this.state.SOL[item.id].disc
                                          : ""
                                      }
                                      onKeyDown={(e) =>
                                        this.state.preventSymbols.includes(
                                          e.key,
                                        ) && e.preventDefault()
                                      }
                                      min="0"
                                      onChange={this.onChangeDiscAmount(
                                        item.id,
                                        item.taxes_id,
                                        item.productId,
                                        item.fixed_price,
                                        item,
                                      )}
                                    />
                                  )}
                                  {this.state.SOL[item.id] !== undefined &&
                                  this.state.SOL[item.id] !== null ? (
                                    <div className="input-group-prepend">
                                      <button
                                        className="littleB"
                                        type="button"
                                        disabled={
                                          this.state.SOL[item.id].qty ==
                                            undefined ||
                                          this.state.SOL[item.id].qty === "" ||
                                          this.state.SOL[item.id].qty === 0
                                            ? true
                                            : false
                                        }
                                        onClick={() =>
                                          this.decrementDiscAmount(
                                            item.id,
                                            item,
                                          )
                                        }
                                      >
                                        -
                                      </button>
                                    </div>
                                  ) : (
                                    <div className="input-group-prepend">
                                      <button
                                        className="littleB"
                                        type="button"
                                        disabled={true}
                                        onClick={() =>
                                          this.decrementDiscAmount(
                                            item.id,
                                            item,
                                          )
                                        }
                                      >
                                        -
                                      </button>
                                    </div>
                                  )}
                                </div>
                              </div> */}

                              {/*<div className="col-4 d-flex flex-row-reverse mt-4">*/}

                              {/*    <h4 className="total">Total Price:  {(this.state.SOL[item.id] === undefined ||*/}
                              {/*        this.state.SOL[item.id].totalPrice === undefined) ? 0 : this.numberWithCommas(this.state.SOL[item.id].totalPrice.toFixed(2))}</h4>*/}
                              {/*</div>*/}
                            </div>
                            {/* ------------------------------------ */}
                            {/* {item.product_packages.length !== 0 && item.product_packages !== null && item.product_packages !== undefined ?
                             item.product_packages.map((package)=>{

                            }) : null  } */}
                            {item.product_packages &&
                            item.product_packages.length !== 0
                              ? item.product_packages.map((pkg) => (
                                  <div className="row mb-3 mt-1">
                                    <div className="col-4" key={pkg.id}>
                                      <p
                                        className="little"
                                        style={stylesASAP.itemTitle}
                                      >
                                        Qty Box (Package Name: {pkg.name}):
                                      </p>
                                      <div className="input-group">
                                        <div className="input-group-prepend">
                                          <button
                                            className="littleB"
                                            type="button"
                                            onClick={() =>
                                              this.incrementQty(
                                                pkg.product_id[0],
                                                item,
                                                pkg.qty,
                                                pkg.id,
                                                // item.uom_id[1]
                                              )
                                            }
                                          >
                                            +
                                          </button>
                                        </div>
                                        <input
                                          className="littleinput"
                                          type="number"
                                          value={
                                            this.state.SOL[item.id] !==
                                              undefined &&
                                            this.state.SOL[item.id] !== null &&
                                            this.state.SOL[item.id].packages[
                                              pkg.id
                                            ] !== undefined &&
                                            this.state.SOL[item.id].packages[
                                              pkg.id
                                            ] !== null
                                              ? this.state.SOL[item.id]
                                                  .packages[pkg.id].qty
                                              : ""
                                          }
                                          onKeyDown={(e) =>
                                            this.state.preventSymbols.includes(
                                              e.key,
                                            ) && e.preventDefault()
                                          }
                                          min="0"
                                          onChange={this.onChangeQty(
                                            pkg.product_id[0],
                                            item.fixed_price,
                                            item.taxes_id,
                                            item,
                                            item.weight,
                                            pkg.qty,
                                            pkg.id,
                                          )}
                                        />
                                        <div className="input-group-prepend">
                                          <button
                                            className="littleB"
                                            type="button"
                                            onClick={() =>
                                              this.dicrementQty(
                                                pkg.product_id[0],
                                                item,
                                                pkg.qty,
                                                pkg.id,
                                              )
                                            }
                                          >
                                            -
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                    {/* <div
                                      className="col-4"
                                      key={`free-box-${pkg.id}`}
                                    >
                                      <p
                                        className="little"
                                        style={stylesASAP.itemTitle}
                                      >
                                        Free BOX (Package Name: {pkg.name}):
                                      </p>
                                      <div className="input-group">
                                        <div className="input-group-prepend">
                                          <button
                                            className="littleB text-center"
                                            onClick={() =>
                                              this.incrementfree(pkg.id, item)
                                            }
                                          >
                                            +
                                          </button>
                                        </div>
                                        <input
                                          className={
                                            this.state.SOL[pkg.id] ===
                                              undefined ||
                                            this.state.SOL[pkg.id] === null ||
                                            this.state.SOL[pkg.id].qty ===
                                              undefined
                                              ? "littleinput disabled"
                                              : "littleinput"
                                          }
                                          type="number"
                                          value={
                                            this.state.SOL[pkg.id] !==
                                              undefined &&
                                            this.state.SOL[pkg.id] !== null &&
                                            this.state.SOL[pkg.id].freeItem !==
                                              undefined
                                              ? this.state.SOL[pkg.id].freeItem
                                              : ""
                                          }
                                          onKeyDown={(e) =>
                                            this.state.preventSymbols.includes(
                                              e.key
                                            ) && e.preventDefault()
                                          }
                                          min="0"
                                          onChange={this.onChangeFreeItems(
                                            pkg.id,
                                            item.fixed_price,
                                            item,
                                            item.weight
                                          )}
                                        />
                                        <div className="input-group-prepend">
                                          <button
                                            className="littleB"
                                            type="button"
                                            onClick={() =>
                                              this.dicrementfree(pkg.id, item)
                                            }
                                          >
                                            -
                                          </button>
                                        </div>
                                      </div>
                                    </div> */}

                                    {/* <div
                                      className="col-4"
                                      key={`disc-box-${pkg.id}`}
                                    >
                                      <p
                                        className="little"
                                        style={stylesASAP.itemTitle}
                                      >
                                        Disc(%) by BOX (Package Name: {pkg.name}
                                        ):
                                      </p>
                                      <div className="input-group">
                                        <div className="input-group-prepend">
                                          <button
                                            className="littleB"
                                            type="button"
                                            disabled={
                                              !this.state.SOL[pkg.id] ||
                                              this.state.SOL[pkg.id].qty ===
                                                undefined ||
                                              this.state.SOL[pkg.id].qty ===
                                                "" ||
                                              this.state.SOL[pkg.id].qty === 0
                                            }
                                            onClick={() =>
                                              this.incrementDisc(pkg.id, item)
                                            }
                                          >
                                            +
                                          </button>
                                        </div>

                                        <input
                                          className="littleinput"
                                          type="number"
                                          disabled={
                                            !this.state.SOL[pkg.id] ||
                                            this.state.SOL[pkg.id].qty ===
                                              undefined ||
                                            this.state.SOL[pkg.id].qty === "" ||
                                            this.state.SOL[pkg.id].qty === 0
                                          }
                                          value={
                                            this.state.SOL[pkg.id] &&
                                            this.state.SOL[pkg.id].disc !==
                                              undefined &&
                                            this.state.SOL[pkg.id].disc !== null
                                              ? this.state.SOL[pkg.id].disc
                                              : ""
                                          }
                                          onKeyDown={(e) =>
                                            this.state.preventSymbols.includes(
                                              e.key
                                            ) && e.preventDefault()
                                          }
                                          min="0"
                                          onChange={this.onChangeDisc(
                                            pkg.id,
                                            item.taxes_id,
                                            item.productId,
                                            item.fixed_price
                                          )}
                                        />

                                        <div className="input-group-prepend">
                                          <button
                                            className="littleB"
                                            type="button"
                                            disabled={
                                              !this.state.SOL[pkg.id] ||
                                              this.state.SOL[pkg.id].qty ===
                                                undefined ||
                                              this.state.SOL[pkg.id].qty ===
                                                "" ||
                                              this.state.SOL[pkg.id].qty === 0
                                            }
                                            onClick={() =>
                                              this.dicrementDisc(pkg.id, item)
                                            }
                                          >
                                            -
                                          </button>
                                        </div>
                                      </div>
                                    </div> */}
                                  </div>
                                ))
                              : null}

                            <div className="row mb-3 mt-1">
                              {/* <div className="col-4">
                                <p
                                  className="little"
                                  style={stylesASAP.itemTitle}
                                >
                                  Qty BOX:
                                </p>
                                <div className="input-group">
                                  <div class="input-group-prepend">
                                    <button
                                      class="littleB"
                                      type="button"
                                      onClick={() =>
                                        this.incrementQty(item.id, item)
                                      }
                                    >
                                      +
                                    </button>
                                  </div>
                                  <input
                                    className="littleinput"
                                    type="number"
                                    value={
                                      this.state.SOL[item.id] !== undefined &&
                                      this.state.SOL[item.id] !== null &&
                                      this.state.SOL[item.id].qty !== undefined
                                        ? this.state.SOL[item.id].qty
                                        : ""
                                    }
                                    onKeyDown={(e) =>
                                      this.state.preventSymbols.includes(
                                        e.key
                                      ) && e.preventDefault()
                                    }
                                    min="0"
                                    onChange={this.onChangeQty(
                                      item.id,
                                      item.fixed_price,
                                      item.taxes_id,
                                      item,
                                      item.weight
                                    )}
                                  />
                                    <div className="input-group-prepend">
                                      <button
                                        className="littleB"
                                      type="button"
                                      onClick={() =>
                                        this.dicrementQty(item.id, item)
                                      }
                                    >
                                      -
                                    </button>
                                  </div>
                                </div>
                              </div> */}
                              {/* <div className="col-4">
                                <p
                                  className="little"
                                  style={stylesASAP.itemTitle}
                                >
                                  Free BOX:
                                </p>
                                  <div className="input-group">
                                  <div className="input-group-prepend">
                                    <button
                                      className="littleB text-center "
                                      onClick={() =>
                                        this.incrementfree(item.id, item)
                                      }
                                    >
                                      +
                                    </button>
                                  </div>
                                  <input
                                    className={
                                      this.state.SOL[index] === undefined ||
                                      this.state.SOL[index] === null ||
                                      this.state.SOL[index].qty === undefined
                                        ? "littleinput disabled"
                                        : "littleinput"
                                    }
                                    type="number"
                                    value={
                                      this.state.SOL[item.id] !== undefined &&
                                      this.state.SOL[item.id] !== null &&
                                      this.state.SOL[item.id].freeItem !==
                                        undefined
                                        ? this.state.SOL[item.id].freeItem
                                        : ""
                                    }
                                    onKeyDown={(e) =>
                                      this.state.preventSymbols.includes(
                                        e.key
                                      ) && e.preventDefault()
                                    }
                                    min="0"
                                    onChange={this.onChangeFreeItems(
                                      item.id,
                                      item.fixed_price,
                                      item,
                                      item.weight
                                    )}
                                  />
                                  <div className="input-group-prepend">
                                    <button
                                      className="littleB"
                                      type="button"
                                      onClick={() =>
                                        this.dicrementfree(item.id, item)
                                      }
                                    >
                                      -
                                    </button>
                                  </div>
                                </div>
                              </div> */}

                              {/* <div className="col-4">
                                <p
                                  className="little"
                                  style={stylesASAP.itemTitle}
                                >
                                  Disc(%) by BOX:
                                </p>
                                <div className="input-group">
                                  {this.state.SOL[item.id] !== undefined &&
                                  this.state.SOL[item.id] !== null ? (
                                    <div className="input-group-prepend">
                                      <button
                                        className="littleB"
                                        type="button"
                                        disabled={
                                          this.state.SOL[item.id].qty ===
                                            undefined ||
                                          this.state.SOL[item.id].qty === "" ||
                                          this.state.SOL[item.id].qty === 0
                                            ? true
                                            : false
                                        }
                                        onClick={() =>
                                          this.incrementDisc(item.id, item)
                                        }
                                      >
                                        +
                                      </button>
                                    </div>
                                  ) : (
                                    <div className="input-group-prepend">
                                      <button
                                        className="littleB"
                                        type="button"
                                        disabled={true}
                                        onClick={() =>
                                          this.incrementDisc(item.id, item)
                                        }
                                      >
                                        +
                                      </button>
                                    </div>
                                  )}
                                  {this.state.SOL[item.id] !== undefined &&
                                  this.state.SOL[item.id] !== null ? (
                                    <input
                                      className="littleinput"
                                      type="number"
                                      disabled={
                                        this.state.SOL[item.id].qty ===
                                          undefined ||
                                        this.state.SOL[item.id].qty === "" ||
                                        this.state.SOL[item.id].qty === 0
                                          ? true
                                          : false
                                      }
                                      value={
                                        this.state.SOL[item.id] !== undefined &&
                                        this.state.SOL[item.id] !== null &&
                                        this.state.SOL[item.id].disc !==
                                          undefined &&
                                        this.state.SOL[item.id].disc !== null
                                          ? this.state.SOL[item.id].disc
                                          : ""
                                      }
                                      onKeyDown={(e) =>
                                        this.state.preventSymbols.includes(
                                          e.key
                                        ) && e.preventDefault()
                                      }
                                      min="0"
                                      onChange={this.onChangeDisc(
                                        item.id,
                                        item.taxes_id,
                                        item.productId,
                                        item.fixed_price
                                      )}
                                    />
                                  ) : (
                                    <input
                                      className="littleinput"
                                      type="number"
                                      disabled={true}
                                      value={
                                        this.state.SOL[item.id] !== undefined &&
                                        this.state.SOL[item.id] !== null &&
                                        this.state.SOL[item.id].disc !==
                                          undefined &&
                                        this.state.SOL[item.id].disc !== null
                                          ? this.state.SOL[item.id].disc
                                          : ""
                                      }
                                      onKeyDown={(e) =>
                                        this.state.preventSymbols.includes(
                                          e.key
                                        ) && e.preventDefault()
                                      }
                                      min="0"
                                      onChange={this.onChangeDisc(
                                        item.id,
                                        item.taxes_id,
                                        item.productId,
                                        item.fixed_price
                                      )}
                                    />
                                  )}
                                  {this.state.SOL[item.id] !== undefined &&
                                  this.state.SOL[item.id] !== null ? (
                                    <div className="input-group-prepend">
                                      <button
                                        className="littleB"
                                        type="button"
                                        disabled={
                                          this.state.SOL[item.id].qty ==
                                            undefined ||
                                          this.state.SOL[item.id].qty === "" ||
                                          this.state.SOL[item.id].qty === 0
                                            ? true
                                            : false
                                        }
                                        onClick={() =>
                                          this.dicrementDisc(item.id, item)
                                        }
                                      >
                                        -
                                      </button>
                                    </div>
                                  ) : (
                                    <div className="input-group-prepend">
                                      <button
                                        className="littleB"
                                        type="button"
                                        disabled={true}
                                        onClick={() =>
                                          this.dicrementDisc(item.id, item)
                                        }
                                      >
                                        -
                                      </button>
                                    </div>
                                  )}
                                </div>
                              </div> */}

                              {/* <div className="col-4 d-flex flex-row-reverse mt-4">

                                  <h4 className="total">Total Price:  {(this.state.SOL[item.id] === undefined ||
                                      this.state.SOL[item.id].totalPrice === undefined) ? 0 : this.numberWithCommas(this.state.SOL[item.id].totalPrice.toFixed(2))}</h4>
                              </div> */}
                            </div>
                            {/* ----------------------------- */}
                            <div className="row mb-3 mt-1">
                              <div className="col-10">
                                <div className="row ">
                                  {(!this.state.settingArray.find(
                                    (s) => s.key === "HideProductStock",
                                  ) ||
                                    this.state.settingArray.find(
                                      (s) => s.key === "HideProductStock",
                                    )?.value === "0") && (
                                    <h6
                                      key={index}
                                      className=" col-3 card-text  text-center "
                                    >
                                      Stock{" "}
                                      {item.external_onhand_qty !== "false"
                                        ? Number(
                                            item.external_onhand_qty,
                                          ).toFixed(this.state.fixed)
                                        : 0}
                                    </h6>
                                  )}
                                  <h6 className=" col-2 ">
                                    {" "}
                                    {item.fixed_price === undefined ||
                                    item.fixed_price === null
                                      ? 0
                                      : item.currency_id !== undefined &&
                                          item.currency_id !== null
                                        ? `${item.currency_id[1]} ${Number(item.fixed_price).toLocaleString("en-US")}`
                                        : Number(
                                            item.fixed_price,
                                          ).toLocaleString("en-US")}
                                  </h6>
                                  <h6 className=" col-2 ">
                                    {this.state.settingArray.map((item) => {
                                      if (
                                        item.key === "EnableItemWeightDisplay"
                                      ) {
                                        return item.value === "1" ? (
                                          <div
                                            className="littlep col-1"
                                            style={stylesASAP.title}
                                          >
                                            {item.weight === undefined ||
                                            item.weight === null ||
                                            item.weight === 0
                                              ? null
                                              : item.weight + " " + "kg"}
                                          </div>
                                        ) : null;
                                      }
                                    })}
                                  </h6>
                                  {/* <h4 className="little col-2 ">
                                  Total{" "}
                                  {this.state.SOL[item.id] === undefined ||
                                    this.state.SOL[item.id] === null ||
                                    this.state.SOL[item.id].totalWeight ===
                                      undefined ||
                                    this.state.SOL[item.id].totalWeight === null
                                    ? 0
                                    : this.state.SOL[item.id].totalWeight }{" "}kg
                                </h4> */}
                                  {/* <h6 className=" col-3 d-flex flex-row-reverse">
                                    Total{" "}
                                    {this.state.SOL[item.id] !== undefined &&
                                    this.state.SOL[item.id] !== null &&
                                    this.state.SOL[item.id].alltotallines !==
                                      undefined &&
                                    this.state.SOL[item.id].alltotallines !==
                                      null
                                      ? Number(
                                          this.state.SOL[item.id].alltotallines,
                                        )
                                          .toFixed(this.state.fixed)
                                          .toLocaleString("en-US")
                                      : this.state.SOL[item.id] !== undefined &&
                                          this.state.SOL[item.id] !== null
                                        ? Number(
                                            this.state.SOL[item.id].totalPrice,
                                          )
                                            .toFixed(this.state.fixed)
                                            .toLocaleString("en-US")
                                        : "0.00"}
                                    {" " + item.currency_id[1]}
                                  </h6> */}
                                  <h6 className="col-3 d-flex flex-row-reverse">
                                    Total{" "}
                                    {this.formatAmount(
                                      this.state.SOL?.[item.id]
                                        ?.alltotallines ??
                                        this.state.SOL?.[item.id]?.totalPrice,
                                    )}
                                    {" " + item.currency_id?.[1]}
                                  </h6>
                                </div>
                              </div>
                            </div>
                            {/* <div className="row">
                                <h4 className="col text-end"><b>BUY {item.description.replace(/<\/?p>/g, "")} FREE</b></h4> 
                            </div> */}
                          </div>
                          {/*<div className="row mt-3">*/}

                          {/*    <h4 key={index} className="little col-4 card-text  text-center ">Stock : {(item.quantity !== undefined) ? item.quantity : 0}</h4>*/}
                          {/*    <h4 className="little col-4 "> {(item.fixed_price === undefined || item.fixed_price === null) ? 0 : (item.currency_id !== undefined && item.currency_id !== null) ? item.currency_id[1] + " " + item.fixed_price : item.fixed_price}</h4>*/}
                          {/*    <h4 className="total col-4 d-flex flex-row-reverse ">Total Price:  {(this.state.SOL[item.id] === undefined ||*/}
                          {/*        this.state.SOL[item.id].totalPrice === undefined) ? 0 : this.numberWithCommas(this.state.SOL[item.id].totalPrice.toFixed(2))}</h4>*/}
                          {/*</div>*/}
                          <br />
                          {/*<div className="row">*/}
                          {/*    <div className="col">*/}
                          {/*        <p className="card-text" style={stylesASAP.itemTitle}>Disc(%):</p>*/}
                          {/*        <input className="form-control" type="number"*/}
                          {/*            value={(this.state.SOL[item.id] !== undefined && this.state.SOL[item.id].disc !== undefined) ? this.state.SOL[item.id].disc : ""}*/}
                          {/*            onKeyDown={e => this.state.preventSymbols.includes(e.key) && e.preventDefault()} min="0"*/}
                          {/*            onChange={this.onChangeDisc(item.id, item.taxes_id, item.id, item.fixed_price)} />*/}
                          {/*    </div>*/}
                          {/*    <div className="col">*/}
                          {/*        <p className="card-text" style={stylesASAP.itemTitle}>Remark:</p>*/}
                          {/*        <input className="form-control" value={(this.state.SOL[item.id] !== undefined && this.state.SOL[item.id].remark !== undefined) ? this.state.SOL[item.id].remark : ""}*/}
                          {/*            onChange={this.onChangeRemark(item.id)} />*/}
                          {/*    </div>*/}
                          {/*    */}
                          {/*<div className="col">*/}
                          {/*    */}
                          {/*    <p className="card-text" style={stylesASAP.itemTitle}>Returned Qty:</p>*/}
                          {/*    */}
                          {/*    <input className="form-control" type="number" value={this.returnValue(item.id)}*/}
                          {/*    */}
                          {/*        onChange={this.onChangeReturnValue(item.id)} />*/}
                          {/*    */}
                          {/*</div>*/}
                          {/*</div>*/}
                          {/*<div className="row ">*/}
                          {/*    <div className="col  d-flex flex-row-reverse">*/}
                          {/*        <h4 className="card-text">Total Price:  {(this.state.SOL[item.id] === undefined ||*/}
                          {/*            this.state.SOL[item.id].totalPrice === undefined) ? 0 : this.numberWithCommas(this.state.SOL[item.id].totalPrice.toFixed(2))}</h4>*/}
                          {/*    </div>*/}
                          {/*</div>*/}
                        </div>
                      );
                    } else {
                      return (
                        <div
                          className="row p-2"
                          style={stylesASAP.mainBackgroundColor}
                          key={index}
                        >
                          <div className="row">
                            <div
                              className="col"
                              style={stylesASAP.cardsecondhalfDelivery}
                            >
                              <h2 className="m-3">{item.name}</h2>
                              <div className="row m-3">
                                <div className="col">
                                  <p
                                    className="card-text"
                                    style={stylesASAP.itemTitle}
                                  >
                                    Ordered Qty:
                                  </p>
                                  <p
                                    className="card-text"
                                    style={stylesASAP.itemTitle}
                                  >
                                    {!this.state.isEmpty
                                      ? item.product_uom_qty
                                      : 0}
                                  </p>
                                </div>
                                <div className="col">
                                  <p
                                    className="card-text"
                                    style={stylesASAP.itemTitle}
                                  >
                                    Delivered Qty:
                                  </p>
                                  <input
                                    className="form-control"
                                    value={
                                      item.deliveredQty !== undefined
                                        ? item.deliveredQty
                                        : ""
                                    }
                                    onChange={this.onChangeQtyDelivery(index)}
                                    type="number"
                                    onKeyDown={(e) =>
                                      this.state.preventSymbols.includes(
                                        e.key,
                                      ) && e.preventDefault()
                                    }
                                    min="0"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    }
                  })
              )
            ) : (
              <div className="pt-2">
                <div className="row" style={stylesASAP.mainBackgroundColor}>
                  {this.state.items.length === 0 ? (
                    <div>
                      <h3 className="card-text text-center text-danger">
                        No items found in this category
                      </h3>
                    </div>
                  ) : (
                    this.state.items
                      .slice(this.state.offset, this.state.offset + 8)
                      .map((item, index) => {
                        return (
                          <div className="pt-2 col-sm-3" key={index}>
                            <div className="card-body text-center bg-light">
                              <div
                                className="col"
                                style={stylesASAP.cancelButtonAlert}
                              >
                                <div className="col">
                                  {this.state.settingArray.map((url) => {
                                    if (url.key === "Product_Images_Base_URL") {
                                      return (
                                        <div className="col-2 mt-2">
                                          {this.state.imageLoaded ? (
                                            <img
                                              className="image1"
                                              src={
                                                url.value +
                                                item.default_code +
                                                ".png?lastmod=" +
                                                this.state.random
                                              }
                                              alt="not found"
                                              onClick={() =>
                                                this.showAlertimage(
                                                  item.default_code,
                                                  item.description,
                                                )
                                              }
                                              onLoad={() => {
                                                this.handleImageLoad(
                                                  item.default_code,
                                                );
                                              }}
                                            />
                                          ) : (
                                            <div
                                              className="spinner-border"
                                              role="status"
                                            >
                                              <span className="visually-hidden">
                                                Loading...
                                              </span>
                                            </div>
                                          )}
                                        </div>
                                      );
                                    }
                                  })}
                                  <div className="col">
                                    <h6 className="card-text">{item.name}</h6>
                                    <h6
                                      className="card-text mt-1 text-center"
                                      style={stylesASAP.code}
                                    >
                                      {item.default_code}
                                    </h6>
                                    <br />
                                    <br />
                                    <div className="row">
                                      <div className="col-6">
                                        <p
                                          className="card-text"
                                          style={stylesASAP.itemTitle}
                                        >
                                          Qty:
                                        </p>
                                        <input
                                          className="form-control"
                                          type="number"
                                          value={
                                            this.state.SOL[item.id] !==
                                              undefined &&
                                            this.state.SOL[item.id] !== null &&
                                            this.state.SOL[item.id].qty !==
                                              undefined
                                              ? this.state.SOL[item.id].qty
                                              : ""
                                          }
                                          onKeyDown={(e) =>
                                            this.state.preventSymbols.includes(
                                              e.key,
                                            ) && e.preventDefault()
                                          }
                                          min="0"
                                          onChange={this.onChangeQty(
                                            item.id,
                                            item.fixed_price,
                                            item.taxes_id,
                                            item,
                                            item.weight,
                                          )}
                                        />
                                      </div>
                                      {/*<div className="col-4">*/}
                                      {/*    <p className="card-text" style={stylesASAP.itemTitle}>Disc(%):</p>*/}
                                      {/*    <input className="form-control" type="number" value={(this.state.SOL[item.id] !== undefined && this.state.SOL[item.id].disc !== undefined) ? this.state.SOL[item.id].disc : ""}*/}
                                      {/*        onKeyDown={e => this.state.preventSymbols.includes(e.key) && e.preventDefault()} min="0"*/}
                                      {/*        onChange={this.onChangeDisc(item.id, item.taxes_id, item.id, item.fixed_price)} />*/}
                                      {/*</div>*/}
                                      <div className="col-6 ">
                                        <p
                                          className="card-text"
                                          style={stylesASAP.itemTitle}
                                        >
                                          Price:{" "}
                                        </p>
                                        <h6
                                          className="col card-text mt-2 "
                                          style={stylesASAP.itemTitle}
                                        >
                                          {" "}
                                          {item.fixed_price === undefined ||
                                          item.fixed_price === null
                                            ? 0
                                            : item.currency_id !== undefined &&
                                                item.currency_id !== null
                                              ? `${item.currency_id[1]} ${Number(item.fixed_price).toLocaleString("en-US")}`
                                              : Number(
                                                  item.fixed_price,
                                                ).toLocaleString("en-US")}{" "}
                                        </h6>
                                      </div>
                                    </div>
                                    <div className="row">
                                      <h6
                                        className="card-text"
                                        style={stylesASAP.marginSelect}
                                      >
                                        Total Price :{" "}
                                        {this.state.SOL[item.id] ===
                                          undefined ||
                                        this.state.SOL[item.id] === null ||
                                        this.state.SOL[item.id].totalPrice ===
                                          undefined
                                          ? 0
                                          : this.numberWithCommas(
                                              this.state.SOL[
                                                item.id
                                              ].totalPrice.toFixed(
                                                this.state.fixed,
                                              ),
                                            )}
                                      </h6>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        );
                      })
                  )}
                </div>
              </div>
            )}
          </div>
          <div className="row mt-4 " style={stylesMed.mainBackgroundColor}>
            <div className="col">
              <ArrowBackOutline
                className="btn"
                color={"#65a0ff"}
                height="50px"
                width="50px"
                onClick={() => this.onPreviousProduct()}
              />
              <h6 className="little">Previous Page</h6>
            </div>
            <div className="col text-center">
              <h6>Page {this.state.countP + " of " + this.state.ofproducts}</h6>
            </div>
            <div className="col" style={stylesMed.rightDirection}>
              <ArrowForwardOutline
                className="btn"
                color={"#65a0ff"}
                height="50px"
                width="50px"
                onClick={() => this.onNextProduct()}
              />
              <h6 className="little">Next Page</h6>
            </div>
          </div>
          <hr style={stylesASAP.enabledStyle} />
          <Modal
            show={this.state.showAlertChange}
            onHide={this.closeAlertChange}
            animation={false}
          >
            <Modal.Header></Modal.Header>
            <div className="col">
              <ArrowBackCircle
                className=" btn"
                onClick={() => this.closeAlertChange()}
                color={"#65a0ff"}
                height="50px"
                width="50px"
              />
            </div>
            <Modal.Body className="text-center">
              <h1>Signature</h1>
            </Modal.Body>
            <Modal.Body>
              <div>
                <div>
                  <div className="pt-3 row">
                    <div className="col d-flex flex-row-reverse">
                      {this.state.checkSignature ? (
                        <div className="savebutton btn" onClick={this.onSave}>
                          Save
                        </div>
                      ) : (
                        <div
                          className="savebutton btn disabled"
                          onClick={this.onSave}
                        >
                          Save
                        </div>
                      )}
                      <div
                        className="btn invisible "
                        onClick={this.checkSignature}
                      >
                        Check
                      </div>
                      <div className="clearButton btn" onClick={this.clear}>
                        Clear
                      </div>
                    </div>
                    <hr />
                  </div>
                  <div className="text-center mt-1 ">
                    {/*  <SignatureComponent className="text-center mt-5 border" style={stylesASAP.signature}> </SignatureComponent>*/}
                    <SignaturePad
                      className="text-center border"
                      style={stylesASAP.signature}
                      ref={this.sign}
                      options={{
                        minWidth: 3,
                        maxWidth: 3,
                        penColor: "#0a0a0a",
                      }}
                    />
                  </div>
                </div>
              </div>
            </Modal.Body>
          </Modal>

          <Modal
            show={this.state.showAlertCancel}
            onHide={this.closeAlertCancel}
            animation={false}
          >
            <Modal.Body>Are You Sure You Want To Cancel this order?</Modal.Body>
            <Modal.Body>
              <div>
                <div
                  className="savebutton btn "
                  onClick={() => this.onCancel()}
                >
                  OK
                </div>
                <div
                  className="cancelButton btn "
                  onClick={() => this.closeAlertCancel()}
                >
                  Cancel
                </div>
              </div>
            </Modal.Body>
          </Modal>

          <Modal show={this.state.showPrint} animation={false}>
            <Modal.Body>
              <Print history={this.props.history}></Print>
            </Modal.Body>
          </Modal>

          <Modal
            className="modal-lg"
            show={this.state.showAlertCatalog}
            onHide={this.closeAlertCatalog}
            animation={false}
          >
            <Modal.Body>
              <div className="row">
                {this.state.catalogs.map((item, index) => (
                  <div className="col-md-6" key={index}>
                    <div className="card ">
                      <div
                        className="card-body btn catalog rounded-3 shadow"
                        style={stylesASAP.fullwidth}
                        onClick={() => this.oncatalog(item.id)}
                      >
                        <h6
                          className="card-title "
                          style={stylesASAP.itemName2}
                        >
                          {item.name}
                        </h6>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </Modal.Body>
          </Modal>

          <Modal
            show={this.state.showAlertimage}
            onHide={this.closeAlertimage}
            animation={false}
          >
            <Modal.Body className="text-center">
              <h3>
                <b>MORE INFORMATION</b>
              </h3>
            </Modal.Body>

            <Modal.Body>
              <div>
                {/* <div className="col-sm-12" style={stylesASAP.sty}>
                  <img
                    className="imageM"
                    src={
                      "https://ghazzawibros.net/images/thumbs/demo_items/" +
                      this.state.defaultCode +
                      ".png"
                    }
                    alt="Not found"
                  />
                </div> */}

                {this.state.settingArray.map((url) => {
                  if (url.key === "Product_Images_Base_URL") {
                    return (
                      <div className="col-sm-12" style={stylesASAP.sty}>
                        <img
                          className="image1"
                          src={
                            url.value +
                            this.state.defaultCode +
                            ".png?lastmod=" +
                            this.state.random
                          }
                          alt="not found"
                        />
                      </div>
                    );
                  }
                })}
                <hr />
                {/* <div className="text-center">
                  <h1> Description </h1>
                  <p className="mt-5">{this.state.description}</p>
                            
                </div> */}
                <div className="text-center">
                  <h1>Description</h1>

                  {this.state.description
                    .replace(/<\/?p>/g, "") // remove <p> and </p>
                    .split("<br>") // split by <br>
                    .map((line, index) => (
                      <p key={index} className="mt-2">
                        {line.trim()}
                      </p>
                    ))}
                </div>
              </div>
            </Modal.Body>
          </Modal>

          <Modal
            show={this.state.showAlertPreview}
            onHide={this.closeAlertPreview}
            animation={false}
            dialogClassName="preview-modal"
          >
            <Modal.Header></Modal.Header>
            <div className="col">
              <ArrowBackCircle
                className=" btn"
                onClick={() => this.closeAlertPreview()}
                color={"#65a0ff"}
                height="50px"
                width="50px"
              />
            </div>
            <Modal.Body className="text-center">
              <h1>Preview</h1>
            </Modal.Body>
            <Modal.Body>
              <div>
                <div className="row " style={stylesASAP.hr}>
                  <div className="littlep col-3" style={stylesASAP.title}>
                    Name
                  </div>
                  <div className="littlep col-1" style={stylesASAP.title}>
                    Qty
                  </div>
                  <div className="littlep col-3" style={stylesASAP.title}>
                    Price
                  </div>
                  {/* {this.state.settingArray.map((item) => {
                    if (item.key === "EnableItemWeightDisplay") {
                      return item.value === "1" ? (
                        <div className="littlep col-1" style={stylesASAP.title}>
                          Kg
                        </div>
                      ) : null;
                    }
                  })} */}
                  {/* <div className="littlep col-1" style={stylesASAP.title}>
                    Kg
                  </div> */}
                  <div className="littlep col-1" style={stylesASAP.title}>
                    Free
                  </div>

                  <div className="littlep col-2" style={stylesASAP.title}>
                    Disc
                  </div>
                  <div className="littlep col-2" style={stylesASAP.title}>
                    Total
                  </div>
                </div>
                <div>
                  {this.state.SOL.filter(
                    (item) => item !== null && item !== undefined,
                  ) // Remove null and undefined values
                    .filter(
                      (item) =>
                        (item.qty && item.qty !== 0) || // Check if qty is valid
                        (item.freeItem && item.freeItem !== 0), // Check if freeItem is valid
                    )
                    .sort((a, b) => a.name.localeCompare(b.name)) // Sort by name A to Z
                    .map((item) => (
                      <div className="row mt-3" key={item.id}>
                        <div className="littlep col-3">{item.name}</div>
                        <div className="littlep col-1">
                          {item.qty !== undefined ? item.qty : 0}
                        </div>
                        {/* <div className="littlep col-3">
                          {item.unitPrice !== undefined
                            ? Number(item.unitPrice).toFixed(2)
                            : 0}
                        </div> */}
                        <div className="littlep col-3">
                          {item.unitPrice != null
                            ? Number(item.unitPrice).toLocaleString("en-US", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })
                            : "0.00"}
                        </div>

                        {/* {this.state.settingArray.map((item) => {
                          if (item.key === "EnableItemWeightDisplay") {
                            return item.value === "1" ? (
                              <div className="littlep col-1">
                                {item.weight === undefined ||
                                item.weight === null
                                  ? 0
                                  : item.weight}
                              </div>
                            ) : null;
                          }
                        })} */}

                        <div className="littlep col-1">
                          {item.freeItem !== undefined ? item.freeItem : 0}
                        </div>

                        <div className="littlep col-2">
                          {item.disc !== undefined ? Number(item.disc) : 0}%
                        </div>
                        {/* <div className="littlep col-2">
                          {item.totalPrice !== undefined
                            ? Number(item.totalPrice).toFixed(this.state.fixed)
                            : 0}
                        </div> */}
                        <div className="littlep col-2">
                          {item.totalPrice != null
                            ? Number(item.totalPrice).toLocaleString("en-US", {
                                minimumFractionDigits:
                                  Number.isInteger(Number(this.state.fixed)) &&
                                  Number(this.state.fixed) >= 0 &&
                                  Number(this.state.fixed) <= 20
                                    ? Number(this.state.fixed)
                                    : 2,
                                maximumFractionDigits:
                                  Number.isInteger(Number(this.state.fixed)) &&
                                  Number(this.state.fixed) >= 0 &&
                                  Number(this.state.fixed) <= 20
                                    ? Number(this.state.fixed)
                                    : 2,
                              })
                            : "0.00"}
                        </div>

                        <hr />
                      </div>
                    ))}
                </div>

                <div className="row">
                  <div className="col">
                    <p className="pt-3 text-center h4 invisible">
                      Untaxed Amount:{" "}
                      {this.numberWithCommas(
                        this.state.totalOrderPriceUntaxed.toFixed(
                          this.state.fixed,
                        ),
                      )}
                    </p>
                  </div>
                  <div className="col">
                    <p className="pt-3 text-center h6 ">
                      VAT:{" "}
                      {this.state.totalVAT !== null
                        ? this.numberWithCommas(
                            this.state.totalVAT.toFixed(this.state.fixed),
                          )
                        : 0}
                    </p>
                  </div>
                  <div className="col">
                    <p className="little pt-3 text-center h6">
                      {this.state.totalWeight !== 0
                        ? "Total-Weight" +
                          " " +
                          this.state.totalWeight +
                          " " +
                          "kg"
                        : null}
                    </p>
                  </div>
                  <div className="col">
                    <p className="pt-3 text-center h6">
                      Total Order Amount:{" "}
                      {this.state.totalOrderPriceTaxed !== null
                        ? Number(
                            this.state.totalOrderPriceTaxed,
                          ).toLocaleString(undefined, {
                            minimumFractionDigits:
                              Number(this.state.fixed) || 2,
                            maximumFractionDigits:
                              Number(this.state.fixed) || 2,
                          })
                        : 0}
                    </p>
                  </div>
                </div>
              </div>
            </Modal.Body>
          </Modal>

          <Modal
            show={this.state.showAlertRemark}
            onHide={this.closeAlertRemark}
            animation={false}
          >
            <Modal.Header className="text-center">REMARK</Modal.Header>
            <div className="col">
              <ArrowBackCircle
                className=" btn"
                onClick={() => this.closeAlertRemark()}
                color={"#65a0ff"}
                height="50px"
                width="50px"
              />
            </div>
            <Modal.Body className="text-center">
              <div className="container mt-2">
                <div className="row justify-content-center">
                  <div className="col">
                    <form>
                      <div className="row">
                        <label
                          htmlFor="exampleFormControlTextarea1"
                          className="form-label"
                        >
                          what's your remark to be filled in?{" "}
                        </label>
                        <textarea
                          className="form-control"
                          value={this.state.inputValue}
                          onChange={this.handleChangeRemark}
                          placeholder="Type something..."
                          rows="3"
                        ></textarea>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </Modal.Body>
          </Modal>

          <Modal
            show={this.state.showAlertImages}
            onHide={this.closeAlertImages}
            animation={false}
          >
            <Modal.Header className="text-center">
              <b>Images Sync</b>
            </Modal.Header>
            <div className="col">
              <ArrowBackCircle
                className=" btn"
                onClick={() => this.closeAlertImages()}
                color={"#65a0ff"}
                height="50px"
                width="50px"
              />
            </div>
            <Modal.Body className="text-center">
              <div className="container col-md-12">
                <div className="row">
                  {this.state.items.map((item, index) => {
                    return (
                      <div className="col-md-3">
                        {this.state.settingArray.map((url) => {
                          if (url.key === "Product_Images_Base_URL") {
                            return (
                              <img
                                className="img-fluid"
                                src={
                                  url.value +
                                  item.default_code +
                                  ".png?lastmod=" +
                                  this.state.random
                                }
                                alt="not found"
                                style={{ width: "100%", height: "100%" }}
                              />
                            );
                          }
                        })}
                      </div>
                    );
                  })}
                </div>
              </div>
            </Modal.Body>
          </Modal>
          {/* {this.state.currentType !== 4 ? (
            <div className="row" style={stylesASAP.mainBackgroundColor}>
              <div className="col">
                <ArrowBackOutline
                  className="btn"
                  color={"#00bfff"}
                  height="50px"
                  width="50px"
                  onClick={() => this.onPreviousCatalog()}
                />
                <h6 className="little">Previous Catalog</h6>
              </div>
              <div className="col text-center">
                <h6>
                  Catalog{" "}
                  {this.state.countC + " of " + this.state.catalogs.length}
                </h6>
              </div>
              <div className="col" style={stylesASAP.floatRight}>
                <ArrowForwardOutline
                  className="btn"
                  color={"#00bfff"}
                  height="50px"
                  width="50px"
                  onClick={() => this.onNextCatalog()}
                />
                <h6 className="little">Next Catalog</h6>
              </div>
            </div>
          ) : null} */}
        </div>
      );
    }
  }
}
